(() => {
  'use strict';

  const config = window.YAFICO_LIGHTING || {};
  const root = document.getElementById('lighting-root');
  if (!root) return;
  const initialStorefrontMarkup = root.getAttribute?.('data-ssr') === 'true' ? root.innerHTML : '';
  let storefrontRendered = false;
  const preview = config.mode !== 'shopify';
  const translations = {
    de: {
      preview: 'ENTWURFSVORSCHAU · Preisvorschläge · keine Bestellung möglich', announcement: 'Skulpturale Lichtobjekte. Für Räume mit Persönlichkeit.', collection: 'Die Kollektion', story: 'Unsere Welt', contact: 'Kontakt', cart: 'Warenkorb', menu: 'Menü', close: 'Schließen', eyebrow: 'YAFICO LIGHTING', hero: 'Wenn Licht<br>zum Gefühl wird.', heroText: 'Organische Formen. Ein warmes Leuchten.<br>Entdecke Lichtobjekte, die deinen Raum verändern.', discover: 'Kollektion entdecken', heroCaption: 'SOREN · Licht in seiner ruhigsten Form', usp1: 'Ausdrucksstarke, organische Formen', usp2: 'Warmweißes LED-Licht', usp3: 'Schirm & LED-Modul im Gesamtpreis', collectionEyebrow: 'DIE LICHTOBJEKTE', collectionTitle: 'Für dein Zuhause.<br>Mit Charakter.', collectionText: 'Manche Dinge geben einem Raum mehr als nur einen neuen Look. Sie geben ihm ein Gefühl. Finde die Form, die zu deinem passt.', all: 'Alle Lichtobjekte', sculptural: 'Sculptural Collection', compact: 'Compact Collection', sort: 'Sortieren', curated: 'Unsere Auswahl', low: 'Preis aufsteigend', high: 'Preis absteigend', objects: 'Lichtobjekte', details: 'Entdecken', inclusive: 'inkl. MwSt.', shipping: 'kostenloser Versand', withKit: 'Gesamtpreis inkl. LED-Modul', editorialEyebrow: 'FORM TRIFFT ATMOSPHÄRE', editorialTitle: 'Am Tag ein Objekt.<br>Am Abend ein Gefühl.', editorialText: 'Schwungvolle Linien, feine Reliefs, überraschende Tiefe. Unsere Lichtobjekte setzen einen bewussten Akzent — auf dem Sideboard, im Regal oder an deinem Lieblingsplatz.', editorialLink: 'AUREL näher kennenlernen', note1: 'Eine neue Perspektive', note1Text: 'Strukturen, die im Tageslicht leise wirken und im warmen Schein eine andere Seite zeigen.', note2: 'Dein Raum. Dein Rhythmus.', note2Text: 'Ein ruhiger Abend, ein gutes Gespräch, ein Moment für dich. Licht gehört dazu.', note3: 'Bewusst ausgewählt', note3Text: 'Zwanzig unterschiedliche Formen. Eine gemeinsame Idee: Licht mit Persönlichkeit.', duoEyebrow: 'ZUSAMMEN GEDACHT', duoTitle: 'Zwei Lichtpunkte.<br>Ein Raumgefühl.', duoText: 'Eine Verbindung zwischen zwei Ecken. Oder zwei Lieblingsplätze, die für sich stehen. Kombiniere die Formen, die sich für dich richtig anfühlen.', duoButton: 'Dein Licht-Duo zusammenstellen', duoNote: 'Zwei Lichtobjekte zum regulären Gesamtpreis. Jeweils mit separatem LED-Modul.', faqEyebrow: 'GUT ZU WISSEN', faqTitle: 'Ein gutes Gefühl.<br>Bis ins Detail.', faq1: 'Was ist im Gesamtpreis enthalten?', faq1Text: 'Ein Lampenschirm und ein separates LED-Kit. Mit einem Klick werden beide Artikel hinzugefügt. Du siehst sie als zwei Positionen im Warenkorb und in der Bestellung.', faq2: 'Wie werden die Artikel geliefert?', faq2Text: 'Lampenschirm und LED-Modul werden separat verpackt geliefert. Das Modul wird nach der modellspezifischen Anleitung eingesetzt. Ein USB-Netzadapter ist nicht enthalten.', faq3: 'Welches Licht erzeugt das Modul?', faq3Text: 'Das MH001 erzeugt warmweißes Licht und wird mit 5 V Gleichspannung betrieben. Die angegebene Leistung beträgt 3 W. Das Objekt ist als stimmungsvolles Akzentlicht gedacht.', faq4: 'Wann wird meine Bestellung versendet?', faq4Text: 'Wir versenden innerhalb von 1–3 Werktagen. Der Versand nach Deutschland und in die Niederlande ist im Preis enthalten. In Deutschland versenden wir mit DHL, in den Niederlanden mit PostNL. Die anschließende Zustellung erfolgt durch den jeweiligen Versanddienstleister.', faq5: 'Kann ich die Artikel zurückgeben?', faq5Text: 'Du kannst Artikel innerhalb von 30 Tagen gemäß unseren Rückgabebedingungen zurückgeben. Informationen zum Ablauf findest du in unseren Rückgabeinformationen. Deine gesetzlichen Rechte bleiben unberührt.', returns: '30 Tage Rückgabe', footerLine: 'Licht mit Charakter.', service: 'Wir sind für dich da', legal: 'Informationen', refund: 'Widerruf & Rückgabe', privacy: 'Datenschutz', terms: 'AGB', imprint: 'Impressum', shippingPolicy: 'Versand', worlds: 'Eine Marke. Viele Welten.', worldsText: 'Lighting · Living · Seasonal', productStory: 'DIE FORM', included: 'Du bestellst zwei einzelne Artikel', shade: 'Lampenschirm', kit: 'LED-Kit', add: 'In den Warenkorb', adding: 'Wird hinzugefügt …', unavailable: 'Nicht verfügbar', productNote: 'Zwei separate Artikel. Separat verpackt. USB-Netzadapter nicht enthalten.', specs: 'Maße & Material', safety: 'Anwendung & Sicherheit', manufacturer: 'Herstellerinformationen', pendingSpecs: 'Die bestätigten Maße und Materialangaben werden vor dem Verkaufsstart ergänzt.', pendingSafety: 'Die modellspezifischen Anwendungs- und Sicherheitshinweise werden vor dem Verkaufsstart ergänzt.', previewDelivery: 'Versand innerhalb von 1–3 Werktagen.', cartTitle: 'Deine Lichtmomente', empty: 'Dein Warenkorb wartet auf sein erstes Lichtobjekt.', continue: 'Kollektion entdecken', remove: 'Entfernen', total: 'Gesamt', checkout: 'Zur Kasse', demoCheckout: 'Vorschau · kein Checkout', cartNote: 'Inkl. MwSt. und kostenlosem Versand nach Deutschland und in die Niederlande.', twoLines: 'Zwei separat gelieferte Artikel mit eigenem Preis. Der LED-Kit ist deiner Auswahl zugeordnet. Entfernst du den Schirm, werden beide Artikel aus dem Warenkorb entfernt.', error: 'Das hat leider nicht geklappt. Bitte prüfe deinen Warenkorb und versuche es erneut.', added: 'Dein Lichtobjekt liegt im Warenkorb.', duoHeading: 'Dein persönliches Licht-Duo', first: 'Erstes Lichtobjekt', second: 'Zweites Lichtobjekt', duoAdd: 'Beide Lichtobjekte hinzufügen', duoPartial: 'Das erste Lichtobjekt wurde hinzugefügt. Das zweite konnte nicht hinzugefügt werden. Bitte prüfe den Warenkorb.', searchEmpty: 'Für diese Auswahl sind noch keine Lichtobjekte vorhanden.', policyPreview: 'Diese Entwurfsvorschau nimmt keine Bestellungen entgegen. Die endgültigen Rechtstexte werden im Shopify-Shop eingebunden und vor dem Verkaufsstart für Lighting geprüft.', back: 'Zur Kollektion', loadError: 'Die Kollektion konnte nicht geladen werden. Bitte lade die Seite erneut.', paymentNote: 'Sichere Zahlung über Shopify', detailsTitle: 'Details', image: 'Produktansicht', availabilityText: 'Dieses Modell wird gerade für den Verkaufsstart vorbereitet. Für Fragen sind wir persönlich erreichbar.'
    },
    nl: {
      preview: 'ONTWERPVOORBEELD · Prijsvoorstellen · bestellen is niet mogelijk', announcement: 'Sculpturale lichtobjecten. Voor ruimtes met karakter.', collection: 'De collectie', story: 'Onze wereld', contact: 'Contact', cart: 'Winkelwagen', menu: 'Menu', close: 'Sluiten', eyebrow: 'YAFICO LIGHTING', hero: 'Als licht<br>een gevoel wordt.', heroText: 'Organische vormen. Een warme gloed.<br>Ontdek lichtobjecten die je ruimte veranderen.', discover: 'Ontdek de collectie', heroCaption: 'SOREN · Licht in zijn rustigste vorm', usp1: 'Expressieve, organische vormen', usp2: 'Warmwit LED-licht', usp3: 'Kap & LED-module in de totaalprijs', collectionEyebrow: 'DE LICHTOBJECTEN', collectionTitle: 'Voor jouw interieur.<br>Met karakter.', collectionText: 'Sommige dingen geven een ruimte meer dan een nieuwe uitstraling. Ze geven haar een gevoel. Vind de vorm die bij jouw ruimte past.', all: 'Alle lichtobjecten', sculptural: 'Sculptural Collection', compact: 'Compact Collection', sort: 'Sorteren', curated: 'Onze selectie', low: 'Prijs oplopend', high: 'Prijs aflopend', objects: 'lichtobjecten', details: 'Ontdekken', inclusive: 'incl. btw', shipping: 'gratis verzending', withKit: 'Totaalprijs inclusief LED-module', editorialEyebrow: 'VORM ONTMOET SFEER', editorialTitle: 'Overdag een object.<br>In de avond een gevoel.', editorialText: 'Vloeiende lijnen, fijne reliëfs, verrassende diepte. Onze lichtobjecten geven een bewust accent — op het dressoir, in de kast of op jouw favoriete plek.', editorialLink: 'Maak kennis met AUREL', note1: 'Een nieuw perspectief', note1Text: 'Structuren die bij daglicht rustig ogen en in de warme gloed een andere kant laten zien.', note2: 'Jouw ruimte. Jouw ritme.', note2Text: 'Een rustige avond, een goed gesprek, een moment voor jezelf. Licht hoort daarbij.', note3: 'Bewust geselecteerd', note3Text: 'Twintig verschillende vormen. Eén gedeeld idee: licht met persoonlijkheid.', duoEyebrow: 'SAMEN GEDACHT', duoTitle: 'Twee lichtpunten.<br>Eén sfeer.', duoText: 'Een verbinding tussen twee hoeken. Of twee favoriete plekken die op zichzelf staan. Combineer de vormen die voor jou goed voelen.', duoButton: 'Stel jouw lichtduo samen', duoNote: 'Twee lichtobjecten voor de reguliere totaalprijs. Elk met een losse LED-module.', faqEyebrow: 'GOED OM TE WETEN', faqTitle: 'Een goed gevoel.<br>Tot in de details.', faq1: 'Wat zit er in de totaalprijs?', faq1Text: 'Een lampenkap en een losse LED-kit. Met één klik worden beide artikelen toegevoegd. Je ziet ze als twee regels in je winkelwagen en bestelling.', faq2: 'Hoe worden de artikelen geleverd?', faq2Text: 'De lampenkap en LED-module worden apart verpakt geleverd. De module wordt geplaatst volgens de instructie voor het model. Een USB-netadapter is niet inbegrepen.', faq3: 'Welk licht geeft de module?', faq3Text: 'De MH001 geeft warmwit licht en werkt op 5 V gelijkspanning. Het opgegeven vermogen is 3 W. Het object is bedoeld als sfeervol accentlicht.', faq4: 'Wanneer wordt mijn bestelling verzonden?', faq4Text: 'We verzenden binnen 1–3 werkdagen. Verzending naar Nederland en Duitsland is inbegrepen in de prijs. In Nederland versturen we met PostNL, in Duitsland met DHL. De bezorging daarna wordt verzorgd door de vervoerder.', faq5: 'Kan ik de artikelen retourneren?', faq5Text: 'Je kunt artikelen binnen 30 dagen retourneren volgens ons retourbeleid. De voorwaarden en werkwijze vind je bij onze retourinformatie. Je wettelijke rechten blijven ongewijzigd.', returns: '30 dagen retourneren', footerLine: 'Licht met karakter.', service: 'We zijn er voor je', legal: 'Informatie', refund: 'Herroeping & retour', privacy: 'Privacy', terms: 'Voorwaarden', imprint: 'Bedrijfsgegevens', shippingPolicy: 'Verzending', worlds: 'Eén merk. Meerdere werelden.', worldsText: 'Lighting · Living · Seasonal', productStory: 'DE VORM', included: 'Je bestelt twee losse artikelen', shade: 'Lampenkap', kit: 'LED-kit', add: 'In winkelwagen', adding: 'Wordt toegevoegd …', unavailable: 'Niet beschikbaar', productNote: 'Twee losse artikelen. Apart verpakt. USB-netadapter niet inbegrepen.', specs: 'Afmetingen & materiaal', safety: 'Gebruik & veiligheid', manufacturer: 'Fabrikantgegevens', pendingSpecs: 'De bevestigde afmetingen en materiaalgegevens worden voor de verkoopstart aangevuld.', pendingSafety: 'De gebruiks- en veiligheidsinstructies per model worden voor de verkoopstart aangevuld.', previewDelivery: 'Verzending binnen 1–3 werkdagen.', cartTitle: 'Jouw lichtmomenten', empty: 'Je winkelwagen wacht op het eerste lichtobject.', continue: 'Ontdek de collectie', remove: 'Verwijderen', total: 'Totaal', checkout: 'Afrekenen', demoCheckout: 'Voorbeeld · geen checkout', cartNote: 'Inclusief btw en gratis verzending naar Nederland en Duitsland.', twoLines: 'Twee apart geleverde artikelen met een eigen prijs. De LED-kit is aan je selectie gekoppeld. Verwijder je de kap, dan verdwijnen beide artikelen uit je winkelmand.', error: 'Dat is helaas niet gelukt. Controleer je winkelwagen en probeer het opnieuw.', added: 'Je lichtobject ligt in de winkelwagen.', duoHeading: 'Jouw persoonlijke lichtduo', first: 'Eerste lichtobject', second: 'Tweede lichtobject', duoAdd: 'Beide lichtobjecten toevoegen', duoPartial: 'Het eerste lichtobject is toegevoegd. Het tweede kon niet worden toegevoegd. Controleer de winkelwagen.', searchEmpty: 'Voor deze selectie zijn nog geen lichtobjecten beschikbaar.', policyPreview: 'Dit ontwerpvoorbeeld neemt geen bestellingen aan. De definitieve juridische teksten worden vanuit Shopify gekoppeld en voor de verkoopstart op Lighting afgestemd.', back: 'Naar de collectie', loadError: 'De collectie kon niet worden geladen. Vernieuw de pagina.', paymentNote: 'Veilig betalen via Shopify', detailsTitle: 'Details', image: 'Productaanzicht', availabilityText: 'Dit model wordt voorbereid voor de verkoopstart. Voor vragen zijn we persoonlijk bereikbaar.'
    }
  };
  translations.nl.faq3Text = 'De losse LED-kit geeft warmwit licht. De module werkt op 5 V USB, heeft een vermogen van 3 W en een kabel van 1,5 meter met bedieningsknop. Een geschikte 5V USB-voeding is nodig. Het licht is bedoeld als sfeervol accentlicht.';
  translations.de.faq3Text = 'Das separate LED-Kit gibt warmweißes Licht ab. Das Modul wird über 5 V USB betrieben, hat eine Leistung von 3 W und ein 1,5 Meter langes Kabel mit Bedientaste. Eine geeignete 5-V-USB-Stromversorgung ist nötig. Das Licht ist als stimmungsvolles Akzentlicht gedacht.';
  translations.nl.faq5 = 'Hoe werkt retourneren en wie betaalt?';
  translations.nl.faq5Text = 'Voor Yafico Lighting heb je 30 dagen bedenktijd. Meld je retour via de bestelomgeving of per e-mail met je bestelnummer. De gewone retourkosten betaal je zelf. Je wettelijke rechten blijven ongewijzigd, ook bij een fout of gebrek. De volledige werkwijze vind je in ons retourbeleid.';
  translations.de.faq5 = 'Wie funktioniert die Rückgabe und wer zahlt?';
  translations.de.faq5Text = 'Für Yafico Lighting hast du 30 Tage Bedenkzeit. Melde deine Rückgabe über die Bestellübersicht oder per E-Mail mit deiner Bestellnummer an. Die gewöhnlichen Rücksendekosten trägst du selbst. Deine gesetzlichen Rechte bleiben unberührt, auch bei einem Fehler oder Mangel. Den vollständigen Ablauf findest du in unseren Rückgabebedingungen.';
  Object.assign(translations.nl, {
    searchEmpty: 'Geen lichtobjecten gevonden met deze filters.', resetFilters: 'Wis filters',
    cartPairIncomplete: 'Je selectie van lampenkap en LED-kit is niet compleet of heeft ongelijke aantallen. Verwijder de betreffende selectie en voeg deze opnieuw toe voordat je afrekent.',
    faq6: 'Welke garantie krijg ik?', faq6Text: 'Je hebt recht op een deugdelijk product. In Nederland heeft wettelijke garantie geen vaste termijn: die hangt af van wat je bij normaal gebruik redelijkerwijs van het product mag verwachten. Werkt iets te vroeg niet zoals het hoort? Neem contact met ons op met je bestelnummer; we bieden de passende wettelijke oplossing, zoals kosteloze reparatie of vervanging.',
    dimensionsLabel: 'Afmetingen', zoom: 'Vergroot de foto', zoomClose: 'Sluit de vergroting', zoomHint: 'Tik of klik op de foto om in en uit te zoomen.',
    quantity: 'Aantal', increase: 'Eén meer', decrease: 'Eén minder', continueShopping: 'Verder winkelen', deliveryLabel: 'Verwachte bezorging', orderBefore: 'Besteld vóór {time} uur', warranty: 'Wettelijke garantie',
    contactTitle: 'Contact & bestelhulp', contactIntro: 'Een vraag over de maat, het licht of je bestelling? We denken graag met je mee, in het Nederlands of Duits.', contactEmail: 'E-mail', contactPhone: 'Telefoon', contactAddress: 'Adres', pairTitle: 'Twee losse artikelen', cartShadeDetail: 'Losse lampenkap · zonder lichtbron', cartKitDetail: 'Losse USB-lichtbron · apart verpakt', cartPairQuantity: 'Aantal van beide artikelen', cartTwoItems: 'Je ziet de lampenkap en LED-kit als twee losse artikelen, ook op je factuur. Samen vormen ze de getoonde totaalprijs.'
  });
  Object.assign(translations.de, {
    searchEmpty: 'Keine Lichtobjekte für diese Filterkombination gefunden.', resetFilters: 'Filter zurücksetzen',
    cartPairIncomplete: 'Deine Auswahl aus Lampenschirm und LED-Kit ist unvollständig oder hat unterschiedliche Stückzahlen. Entferne die betroffene Auswahl und füge sie vor dem Bezahlen erneut hinzu.',
    faq6: 'Welche Garantie habe ich?', faq6Text: 'Für jeden Lampenschirm und jedes LED-Modul gilt die gesetzliche Gewährleistung von 2 Jahren. Funktioniert etwas nicht so, wie es soll? Schreib uns mit Bestellnummer und Foto; wir lösen es mit einer Reparatur oder einem Ersatz.',
    dimensionsLabel: 'Maße', zoom: 'Foto vergrößern', zoomClose: 'Vergrößerung schließen', zoomHint: 'Tippe oder klicke auf das Foto, um hinein- und herauszuzoomen.',
    quantity: 'Anzahl', increase: 'Eins mehr', decrease: 'Eins weniger', continueShopping: 'Weiter einkaufen', deliveryLabel: 'Voraussichtliche Lieferung', orderBefore: 'Bestellt vor {time} Uhr', warranty: '2 Jahre Gewährleistung',
    contactTitle: 'Kontakt & Bestellhilfe', contactIntro: 'Eine Frage zur Größe, zum Licht oder zu deiner Bestellung? Wir denken gerne mit, auf Deutsch oder Niederländisch.', contactEmail: 'E-Mail', contactPhone: 'Telefon', contactAddress: 'Adresse', pairTitle: 'Zwei separate Artikel', cartShadeDetail: 'Separater Lampenschirm · ohne Lichtquelle', cartKitDetail: 'Separate USB-Lichtquelle · separat verpackt', cartPairQuantity: 'Anzahl beider Artikel', cartTwoItems: 'Lampenschirm und LED-Kit sind zwei separate Artikel, auch auf deiner Rechnung. Zusammen ergeben sie den angezeigten Gesamtpreis.'
  });
  let locale = ['de', 'nl'].includes(config.locale) ? config.locale : 'de';
  const initialLanguage = new URLSearchParams(location.search).get('lang');
  if (preview && ['de', 'nl'].includes(initialLanguage)) locale = initialLanguage;
  let text = translations[locale];
  let products = [];
  const variantSelections = new Map();
  let filter = 'all';
  let footprint = 'all';
  let sorting = 'curated';
  let cart;
  let activeProduct;
  let inlineProduct;
  let purchaseObserver;
  let productEntry;
  let productReturnPage;
  let initialPageMetadata;
  const dialogFocus = new WeakMap();
  let galleryIndex = 0;
  let galleryRequestedIndex = 0;
  let galleryRevision = 0;
  let gallerySession = 0;
  let galleryWarmRevision = 0;
  let zoomRevision = 0;
  const galleryPhotos = new Map();
  let galleryPointer;
  let busy = false;
  let cartState = { items: [], item_count: 0, total_price: 0 };
  const preferred = ['03', '01', '10', '07', '05', '04', '06', '09', '08', '02', '16', '15', '14', '11', '19', '13', '17', '18', '20', '12'];
  const icons = {
    arrow: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 12h15m-5-5 5 5-5 5" stroke="currentColor" stroke-width="1.4"/></svg>',
    bag: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 7.5h14l1 13H4l1-13Z" stroke="currentColor" stroke-width="1.25"/><path d="M8.5 8V5a3.5 3.5 0 0 1 7 0v3" stroke="currentColor" stroke-width="1.25"/></svg>',
    plus: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="1.2"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="m6 6 12 12M18 6 6 18" stroke="currentColor" stroke-width="1.3"/></svg>',
    menu: '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 8h16M4 16h16" stroke="currentColor" stroke-width="1.3"/></svg>'
  };

  function escape(value) {
    return String(value ?? '').replace(/[&<>"']/g, character => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[character]));
  }

  function money(cents) {
    return new Intl.NumberFormat(locale === 'de' ? 'de-DE' : 'nl-NL', { style: 'currency', currency: config.currency || 'EUR', maximumFractionDigits: 2, minimumFractionDigits: Number(cents) % 100 ? 2 : 0 }).format(Number(cents) / 100);
  }

  let cachedMediaMasters;
  let mediaMasterIndex = new Map();
  let cachedMediaThumbnails;
  let mediaThumbnailIndex = new Map();

  function mediaMaster(filename) {
    const masters = config.mediaMasters || window.YaficoMediaMasters;
    if (!masters) return undefined;
    if (cachedMediaMasters !== masters) {
      cachedMediaMasters = masters;
      mediaMasterIndex = new Map(Object.entries(masters).map(([name, master]) => [mediaStem(name), master]));
    }
    const basename = String(filename).split(/[?#]/)[0].split('/').pop();
    return masters[basename] || mediaMasterIndex.get(mediaStem(filename));
  }

  function asset(filename) {
    const resolved = mediaMaster(filename)?.displaySrc || filename;
    if (/^(https?:)?\/\//.test(resolved) || resolved.startsWith('/')) return resolved;
    return `${config.assetBase || 'assets/'}${resolved}`;
  }

  function mediaStem(filename) {
    let basename;
    try {
      basename = decodeURIComponent(new URL(filename, location.href).pathname.split('/').pop());
    } catch {
      basename = String(filename).split(/[?#]/)[0].split('/').pop();
    }
    return basename.replace(/\.[^.]+$/, '').replace(/_(?:[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}|[a-f0-9]{32}|\d+)$/i, '');
  }

  function matchesProductMedia(filename, knownImages) {
    const stem = mediaStem(filename);
    return knownImages.some(imageName => mediaStem(imageName) === stem);
  }

  function productText(...values) {
    return values.find(value => typeof value === 'string' && value.trim())?.trim() || '';
  }

  function materialText(...values) {
    return productText(...values)
      .replace(/\s*\(\s*Bambu[\s-]*Lab(?:®|™)?\s*\)/gi, '')
      .replace(/\bBambu[\s-]*Lab(?:®|™)?[\s·:–—-]*(?=PLA\b)/gi, '').trim();
  }

  function dimensionText(value) {
    return value.replace(/^((?:ca\.\s*)?B\s*\d+(?:[.,]\d+)?\s*×\s*)[DT](\s*\d+(?:[.,]\d+)?\s*×\s*H\s*\d+(?:[.,]\d+)?\s*cm)$/, '$1' + (locale === 'de' ? 'T' : 'D') + '$2');
  }

  function nextFrame(callback) {
    if (typeof window.requestAnimationFrame === 'function') window.requestAnimationFrame(callback);
    else setTimeout(callback, 0);
  }

  const deliveryHolidayCache = new Map();
  const deliveryEstimateCache = new Map();
  const deliveryClock = new Intl.DateTimeFormat('en-CA', { timeZone: 'Europe/Amsterdam', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23' });

  function calendarKey(date) {
    return date.toISOString().slice(0, 10);
  }

  function easterDate(year) {
    const goldenYear = year % 19;
    const century = Math.floor(year / 100);
    const yearOfCentury = year % 100;
    const centuryLeap = Math.floor(century / 4);
    const centuryRemainder = century % 4;
    const solarCorrection = Math.floor((century + 8) / 25);
    const lunarCorrection = Math.floor((century - solarCorrection + 1) / 3);
    const epact = (19 * goldenYear + century - centuryLeap - lunarCorrection + 15) % 30;
    const yearLeap = Math.floor(yearOfCentury / 4);
    const yearRemainder = yearOfCentury % 4;
    const weekdayCorrection = (32 + 2 * centuryRemainder + 2 * yearLeap - epact - yearRemainder) % 7;
    const monthCorrection = Math.floor((goldenYear + 11 * epact + 22 * weekdayCorrection) / 451);
    const easterMonth = Math.floor((epact + weekdayCorrection - 7 * monthCorrection + 114) / 31);
    const easterDay = (epact + weekdayCorrection - 7 * monthCorrection + 114) % 31 + 1;
    return new Date(Date.UTC(year, easterMonth - 1, easterDay));
  }

  function deliveryHolidays(year, country) {
    const cacheKey = `${year}-${country}`;
    if (deliveryHolidayCache.has(cacheKey)) return deliveryHolidayCache.get(cacheKey);
    const holidays = new Set([`${year}-01-01`, `${year}-12-25`, `${year}-12-26`]);
    const easter = easterDate(year);
    for (const offset of [-2, 1, 39, 50]) {
      const date = new Date(easter);
      date.setUTCDate(date.getUTCDate() + offset);
      holidays.add(calendarKey(date));
    }
    if (country === 'DE') {
      holidays.add(`${year}-05-01`);
      holidays.add(`${year}-10-03`);
    } else {
      const kingsDay = new Date(Date.UTC(year, 3, 27));
      if (kingsDay.getUTCDay() === 0) kingsDay.setUTCDate(26);
      holidays.add(calendarKey(kingsDay));
      holidays.add(`${year}-05-05`);
    }
    deliveryHolidayCache.set(cacheKey, holidays);
    return holidays;
  }

  function isDeliveryDay(date, country) {
    return date.getUTCDay() !== 0 && date.getUTCDay() !== 6 && !deliveryHolidays(date.getUTCFullYear(), country).has(calendarKey(date));
  }

  function businessDaysAfter(date, days, country = 'NL') {
    const result = new Date(date);
    let added = 0;
    while (added < days) {
      result.setUTCDate(result.getUTCDate() + 1);
      if (isDeliveryDay(result, country)) added += 1;
    }
    return result;
  }

  function deliveryEstimate(now = new Date()) {
    const cro = config.cro || {};
    const configuredCutoff = Number(cro.cutoffHour);
    const cutoff = Number.isInteger(configuredCutoff) && configuredCutoff >= 0 && configuredCutoff <= 23 ? configuredCutoff : 16;
    const transitValue = String(cro.transit?.[locale] || (locale === 'de' ? '2-4' : '1-2'));
    const transitMatch = /^(\d{1,2})(?:[-–](\d{1,2}))?$/.exec(transitValue);
    const transitMin = transitMatch ? Math.max(1, Number(transitMatch[1])) : locale === 'de' ? 2 : 1;
    const transitMax = Math.max(transitMin, transitMatch ? Number(transitMatch[2] || transitMatch[1]) : locale === 'de' ? 4 : 2);
    if (!(now instanceof Date) || !Number.isFinite(now.getTime())) return { text: '', cutoff: '' };
    const cacheKey = `${locale}:${cutoff}:${transitMin}:${transitMax}:${Math.floor(now.getTime() / 60000)}`;
    if (deliveryEstimateCache.has(cacheKey)) return deliveryEstimateCache.get(cacheKey);
    const parts = Object.fromEntries(deliveryClock.formatToParts(now).filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
    const orderDay = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day)));
    const processingDay = isDeliveryDay(orderDay, 'NL') && Number(parts.hour) < cutoff ? orderDay : businessDaysAfter(orderDay, 1, 'NL');
    const firstDispatch = businessDaysAfter(processingDay, 1, 'NL');
    const lastDispatch = businessDaysAfter(processingDay, 3, 'NL');
    const destination = locale === 'de' ? 'DE' : 'NL';
    const from = businessDaysAfter(firstDispatch, transitMin, destination);
    const to = businessDaysAfter(lastDispatch, transitMax, destination);
    const formatter = new Intl.DateTimeFormat(locale === 'de' ? 'de-DE' : 'nl-NL', { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' });
    const clean = value => value.replace(/\.(?=\s|$)/g, '').replace(/,/g, '');
    const estimate = {
      from, to,
      text: `${clean(formatter.format(from))} – ${clean(formatter.format(to))}`,
      cutoff: `${text.orderBefore.replace('{time}', `${String(cutoff).padStart(2, '0')}:00`)} (${locale === 'de' ? 'Amsterdamer Zeit' : 'Nederlandse tijd'})`
    };
    deliveryEstimateCache.set(cacheKey, estimate);
    if (deliveryEstimateCache.size > 4) deliveryEstimateCache.delete(deliveryEstimateCache.keys().next().value);
    return estimate;
  }

  function dimensionImageFor(product) {
    return `lighting-${product.id}-dimensions-v1.webp`;
  }

  function image(product, position) {
    if (position === undefined && product.studioImage) return asset(product.studioImage);
    return asset(product.images[Math.min(position ?? 0, product.images.length - 1)]);
  }

  function thumbnail(product, position = 0) {
    const filename = product.images[Math.min(position, product.images.length - 1)];
    const thumbnails = window.YaficoMediaThumbnails || {};
    if (cachedMediaThumbnails !== thumbnails) {
      cachedMediaThumbnails = thumbnails;
      mediaThumbnailIndex = new Map(Object.entries(thumbnails).map(([name, entry]) => [mediaStem(name), entry]));
    }
    const basename = String(filename).split(/[?#]/)[0].split('/').pop();
    const entry = thumbnails[basename] || mediaThumbnailIndex.get(mediaStem(filename));
    return typeof entry?.src === 'string' && entry.src ? asset(entry.src) : asset(filename);
  }

  function photoSource(product, position = 0) {
    const filename = product.images[Math.min(position, product.images.length - 1)];
    const src = image(product, position);
    const master = mediaMaster(filename);
    const width = Number(master?.width);
    const height = Number(master?.height);
    if (!master?.src || !Number.isFinite(width) || !Number.isFinite(height) || width <= 0 || height <= 0) return { src, zoomSrc: src };
    const zoomSrc = asset(master.src);
    const originalWidth = Number(master.originalWidth);
    const originalHeight = Number(master.originalHeight);
    const hasOriginalSize = Number.isFinite(originalWidth) && originalWidth > 0 && originalWidth < width && Number.isFinite(originalHeight) && originalHeight > 0;
    const candidates = new Map();
    if (Array.isArray(master.sources)) {
      for (const source of master.sources) {
        const sourceWidth = Number(source?.width);
        if (typeof source?.src !== 'string' || !source.src || /[\s,]/.test(source.src) || !Number.isSafeInteger(sourceWidth) || sourceWidth <= 0 || sourceWidth > width) continue;
        candidates.set(sourceWidth, `${asset(source.src)} ${sourceWidth}w`);
      }
    }
    const srcset = candidates.size
      ? [...candidates].sort(([firstWidth], [secondWidth]) => firstWidth - secondWidth).map(([, source]) => source).join(', ')
      : hasOriginalSize ? `${src} ${originalWidth}w, ${zoomSrc} ${width}w` : `${zoomSrc} ${width}w`;
    return {
      src,
      srcset,
      sizes: '(max-width: 700px) 100vw, (max-width: 1700px) 49vw, 830px',
      width: hasOriginalSize ? originalWidth : width,
      height: hasOriginalSize ? originalHeight : height,
      zoomSrc,
      zoomWidth: width,
      zoomHeight: height
    };
  }

  function responsivePhotoAttributes(source) {
    return source.srcset ? ` srcset="${escape(source.srcset)}" sizes="${escape(source.sizes)}"` : '';
  }

  function productUrl(product) {
    if (preview && config.productPages === true) {
      const target = new URL(location.href);
      target.searchParams.set('lang', locale);
      target.searchParams.set('product', product.id);
      if (product.colorKey && product.variantId) target.searchParams.set('variant', product.variantId);
      else target.searchParams.delete('variant');
      return `${target.pathname}${target.search}`;
    }
    if (preview || !product?.url) return `#model-${product.id}`;
    try {
      const sourcePath = String(product.url).split(/[?#]/)[0];
      const decodedSource = decodeURIComponent(sourcePath);
      if (/[\\\u0000-\u001f\u007f]/.test(decodedSource) || /%(?:2f|5c)/i.test(sourcePath + decodedSource)
        || /(?:^|\/)\.{1,2}(?:\/|$)/.test(decodedSource)) return `#model-${product.id}`;
      const target = new URL(product.url, location.href);
      const decodedPath = decodeURIComponent(target.pathname);
      if (target.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[^/]+\/?$/i.test(target.pathname)
        || /[\\\u0000-\u001f\u007f]/.test(decodedPath) || /%(?:2f|5c)/i.test(target.pathname + decodedPath)
        || decodedPath.includes('//') || /(?:^|\/)\.{1,2}(?:\/|$)/.test(decodedPath)) return `#model-${product.id}`;
      const draft = new URLSearchParams(location.search).get('preview_theme_id');
      const params = new URLSearchParams();
      if (config.productPages === true && /^\d+$/.test(draft || '')) params.set('preview_theme_id', draft);
      if (product.colorKey && /^[1-9]\d*$/.test(String(product.variantId || ''))) params.set('variant', product.variantId);
      return `${target.pathname}${params.size ? `?${params}` : ''}`;
    } catch {
      return `#model-${product.id}`;
    }
  }

  function pageMetadata() {
    return {
      url: `${location.pathname}${location.search}${location.hash.startsWith('#model-') ? '' : location.hash}`,
      title: document.title,
      description: document.querySelector('meta[name="description"]')?.getAttribute('content') ?? null,
      canonical: document.querySelector('link[rel="canonical"]')?.getAttribute('href') ?? null,
      alternates: Object.fromEntries(['nl', 'de', 'x-default'].map(language => [language, document.querySelector(`link[rel="alternate"][hreflang="${language}"]`)?.getAttribute('href') ?? null])),
      schema: document.getElementById('LightingProductSchema')?.textContent ?? null
    };
  }

  function setMetadataElement(selector, tagName, attributes, value, contentAttribute) {
    let element = document.querySelector(selector);
    if (value === null) {
      element?.remove();
      return;
    }
    if (!element) {
      element = document.createElement(tagName);
      Object.entries(attributes).forEach(([name, attribute]) => element.setAttribute(name, attribute));
      document.head.appendChild(element);
    }
    if (contentAttribute) element.setAttribute(contentAttribute, value);
    else element.textContent = value;
  }

  function applyPageMetadata(metadata) {
    document.title = metadata.title;
    setMetadataElement('meta[name="description"]', 'meta', { name: 'description' }, metadata.description, 'content');
    setMetadataElement('link[rel="canonical"]', 'link', { rel: 'canonical' }, metadata.canonical, 'href');
    if (metadata.alternates) Object.entries(metadata.alternates).forEach(([language, url]) => {
      if (['nl', 'de', 'x-default'].includes(language)) setMetadataElement(`link[rel="alternate"][hreflang="${language}"]`, 'link', { rel: 'alternate', hreflang: language }, url, 'href');
    });
    setMetadataElement('#LightingProductSchema', 'script', { id: 'LightingProductSchema', type: 'application/ld+json' }, metadata.schema);
  }

  function updateProductMetadata(product, destination) {
    if (preview) {
      document.title = `${product.name} · Yafico Lighting`;
      return;
    }
    if (destination.startsWith('#')) return;
    const metadataUrls = productMetadataUrls(product, destination);
    const schema = productSelectionMetadata(product, metadataUrls.canonical);
    if (config.activeProductId === product.id && initialPageMetadata) {
      const selectionSchema = /^YL-SELECT-/.test(String(product.structuredData?.sku || '')) || /"sku"\s*:\s*"YL-SELECT-/.test(initialPageMetadata.schema || '');
      applyPageMetadata(selectionSchema ? { ...initialPageMetadata, schema } : initialPageMetadata);
      return;
    }
    applyPageMetadata({
      title: `${product.shopifyTitle || product.name} · Yafico Lighting`,
      description: product.detail[locale],
      canonical: metadataUrls.canonical,
      alternates: metadataUrls.alternates,
      schema
    });
  }

  function productSelectionMetadata(product, canonical) {
    const source = product.structuredData;
    if (!config.enabled || !/^YL-SELECT-[1-9]\d*$/.test(String(source?.sku || '')) || !/^[1-9]\d*$/.test(String(product.variantId || '')) || !/^[1-9]\d*$/.test(String(config.kit?.variantId || '')) || !Number.isSafeInteger(product.shadePrice) || product.shadePrice < 0 || !Number.isSafeInteger(config.kit.price) || config.kit.price < 0 || (config.currency || 'EUR') !== 'EUR' || !canonical) return null;
    const identity = `YL-SELECT-${product.variantId}`;
    const selected = product.variants?.find(variant => String(variant.id) === String(product.variantId));
    const url = new URL(canonical);
    url.searchParams.set('country', locale === 'nl' ? 'NL' : 'DE');
    url.searchParams.set('variant', product.variantId);
    const schema = JSON.parse(JSON.stringify(source));
    schema['@id'] = `${url.href}#selection`;
    schema.sku = identity;
    schema.url = url.href;
    const selectedMpn = selected?.mpn || (source.sku === identity ? source.mpn : null);
    if (selectedMpn) schema.mpn = selectedMpn;
    else delete schema.mpn;
    if (product.colorLabel) schema.color = product.colorLabel;
    if (source.sku !== identity) {
      const candidates = Array.isArray(product.images) && product.images.length ? product.images.map(filename => asset(filename)) : [selected?.image || (product.studioImage ? asset(product.studioImage) : null)];
      const images = [...new Set(candidates.filter(Boolean).map(value => {
        try {
          const target = new URL(value, location.href);
          return target.protocol === 'https:' ? target.href : null;
        } catch {
          return null;
        }
      }).filter(Boolean))];
      if (images.length) schema.image = images;
      else delete schema.image;
      const material = [product.colorMaterial, product.material].find(value => typeof value === 'string' && value.trim())?.trim();
      if (material) schema.material = material;
      else delete schema.material;
    }
    const shade = schema.additionalProperty?.find(property => property.propertyID === 'shade_sku');
    if (shade && (selected?.sku || product.sku)) shade.value = selected?.sku || product.sku;
    schema.offers = {
      ...schema.offers,
      '@id': `${url.href}#offer`,
      url: url.href,
      price: (product.shadePrice + config.kit.price) / 100,
      priceCurrency: 'EUR',
      availability: product.available === true && config.kit.available === true ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock'
    };
    return JSON.stringify(schema);
  }

  function productMetadataUrls(product, destination) {
    const hosts = { nl: 'https://lighting.yafico.nl', de: 'https://leuchten.yafico.de' };
    const validProductUrl = (value, language) => {
      try {
        const target = new URL(value, hosts[language]);
        if (target.origin !== hosts[language] || !/^\/products\/[a-z0-9-]+$/.test(target.pathname)) return null;
        return `${target.origin}${target.pathname}`;
      } catch {
        return null;
      }
    };
    const canonical = validProductUrl(product.canonicalUrl, locale) || validProductUrl(destination, locale);
    const alternateNl = validProductUrl(product.alternateUrls?.nl, 'nl');
    const alternateDe = validProductUrl(product.alternateUrls?.de, 'de');
    return {
      canonical,
      alternates: alternateNl && alternateDe ? { nl: alternateNl, de: alternateDe, 'x-default': alternateNl } : { nl: null, de: null, 'x-default': null }
    };
  }

  function policyLink(kind, label) {
    const url = config.policies?.[kind];
    return url ? `<a href="${escape(url)}">${label}</a>` : `<button class="yl-text-button" data-policy="${kind}">${label}</button>`;
  }

  function isCanonicalCartPage() {
    return config.template === 'cart' && ['lighting.yafico.nl', 'leuchten.yafico.de'].includes(location.hostname);
  }

  function brandContext() {
    const home = preview ? `${location.pathname}?lang=${locale}` : config.root || '/';
    return { config, root, locale, text, products, icons, asset, image, thumbnail, photoSource, escape, money, policyLink, productUrl, preview, cartState, filter, footprint, sorting, galleryIndex, galleryLabel, delivery: deliveryEstimate(), cro: config.cro || {}, homeHref: inlineProduct || isCanonicalCartPage() ? home : '#', collectionHref: inlineProduct || isCanonicalCartPage() ? `${home}#collection` : '#collection' };
  }

  function pageProduct() {
    const modelId = preview ? new URLSearchParams(location.search).get('product') : config.template === 'product' ? config.activeProductId : null;
    return /^(?:0[1-9]|1\d|20)$/.test(modelId || '') ? selectedProduct(modelId) : null;
  }

  function selectedProduct(modelId, selection) {
    const product = products.find(candidate => candidate.id === modelId);
    if (!product || !window.YaficoVariants) return product;
    const requested = selection || variantSelections.get(modelId) || new URLSearchParams(location.search).get('variant');
    return window.YaficoVariants.select(brandContext(), product, requested);
  }

  function changeVariant(modelId, selection) {
    if (busy || !activeProduct || activeProduct.id !== modelId || !window.YaficoVariants) return;
    const selected = selectedProduct(modelId, selection);
    if (!selected?.colorChoices?.some(choice => choice.key === selection || String(choice.variantId) === String(selection))) return;
    variantSelections.set(modelId, selected.colorKey);
    galleryIndex = 0;
    if (inlineProduct) {
      render();
      renderCart();
      const destination = productUrl(selected);
      if (!destination.startsWith('#')) history.replaceState(null, '', destination);
    } else {
      openProduct(modelId);
    }
    nextFrame(() => root.querySelector(`[data-lighting-variant="${selected.colorKey}"]`)?.focus?.({ preventScroll: true }));
  }

  function render() {
    invalidateGallery();
    products.forEach(product => { product.dimensions = dimensionText(product.dimensions); });
    if (preview) config.contactEmail = `info@yafico.${locale}`;
    document.documentElement.lang = locale;
    if (preview) document.title = config.activeProductId ? `${products.find(product => product.id === config.activeProductId)?.name || 'Kollektion'} · Yafico Lighting` : `Yafico Lighting — ${text.footerLine}`;
    inlineProduct = pageProduct();
    const leadSelector = inlineProduct ? '.yl-gallery-main' : '.yb-hero-image';
    const firstPaintPhoto = !storefrontRendered && root.getAttribute?.('data-ssr') === 'true' ? root.querySelector(leadSelector) : null;
    root.removeAttribute?.('data-ssr');
    if (inlineProduct) {
      activeProduct = inlineProduct;
      updateProductMetadata(inlineProduct, productUrl(inlineProduct));
      const purchasable = preview || (config.enabled && inlineProduct.available && inlineProduct.variantId && config.kit.available && config.kit.variantId);
      root.innerHTML = window.YaficoBrand.shell({ ...brandContext(), pageContent: window.YaficoPurchase.page(brandContext(), inlineProduct, purchasable) });
    } else if (isCanonicalCartPage()) {
      root.innerHTML = window.YaficoBrand.shell({ ...brandContext(), pageContent: `<main id="lighting-main" class="lighting-document"><p class="yl-eyebrow">YAFICO LIGHTING</p><h1>${escape(text.cartTitle)}</h1><p><button type="button" class="yl-button" data-cart>${escape(text.cart)}${icons.arrow}</button></p><p><a href="${escape(brandContext().collectionHref)}">${escape(text.continueShopping)}</a></p></main>` });
    } else {
      root.innerHTML = window.YaficoBrand.shell(brandContext());
      const sort = root.querySelector('[data-sort]');
      if (sort) sort.value = sorting;
      renderProducts();
    }
    if (firstPaintPhoto) reuseFirstPaintPhoto(firstPaintPhoto, root.querySelector(leadSelector));
    window.YaficoBrand.mount(brandContext());
    storefrontRendered = true;
    window.YaficoProductTools?.mount(brandContext(), inlineProduct);
    if (inlineProduct) {
      warmGallery();
    }
    purchaseObserver?.disconnect();
    if (inlineProduct && window.IntersectionObserver) {
      const sticky = root.querySelector('.yp-sticky');
      const buy = root.querySelector('.yp-buy-panel [data-add]');
      purchaseObserver = new window.IntersectionObserver(([entry]) => {
        sticky.dataset.visible = String(!entry.isIntersecting && entry.boundingClientRect.top < 0);
      }, { threshold: 0 });
      purchaseObserver.observe(buy);
    }
  }

  function leadPhotoSignature(photo) {
    if (!photo?.getAttribute) return null;
    const absolute = value => new URL(value, location.href).href;
    try {
      const src = photo.getAttribute('src');
      if (!src) return null;
      const candidates = String(photo.getAttribute('srcset') || '').split(',').filter(value => value.trim()).map(value => {
        const [url, descriptor, ...extra] = value.trim().split(/\s+/);
        if (!url || !/^\d+(?:\.\d+)?[wx]$/.test(descriptor) || extra.length) throw new Error('Unexpected responsive candidate');
        return `${absolute(url)} ${descriptor}`;
      });
      return JSON.stringify([absolute(src), candidates, String(photo.getAttribute('sizes') || '').trim().replace(/\s+/g, ' '), photo.getAttribute('width'), photo.getAttribute('height'), photo.closest?.('.yx-gallery-stage')?.dataset.studio ?? null]);
    } catch {
      return null;
    }
  }

  function reuseFirstPaintPhoto(previous, replacement) {
    if (!replacement?.replaceWith || previous === replacement) return;
    const signature = leadPhotoSignature(previous);
    if (!signature || signature !== leadPhotoSignature(replacement)) return;
    // Keep the in-flight/decoded server image, but use the current caption and class.
    // Source/geometry equality prevents carrying an image into another colour or view.
    for (const attribute of Array.from(replacement.attributes)) {
      if (!['src', 'srcset', 'sizes'].includes(attribute.name)) previous.setAttribute(attribute.name, attribute.value);
    }
    replacement.replaceWith(previous);
  }

  const stateParams = { filter: 'lijn', footprint: 'maat', sorting: 'sortering' };

  function readCollectionState() {
    const params = new URLSearchParams(location.search);
    const requested = {
      filter: params.get(stateParams.filter),
      footprint: params.get(stateParams.footprint),
      sorting: params.get(stateParams.sorting)
    };
    filter = ['all', 'sculptural', 'compact'].includes(requested.filter) ? requested.filter : 'all';
    footprint = ['all', '15', '17', '18'].includes(requested.footprint) ? requested.footprint : 'all';
    sorting = ['curated', 'low', 'high'].includes(requested.sorting) ? requested.sorting : 'curated';
  }

  function writeCollectionState() {
    if (preview) return;
    try {
      const url = new URL(location.href);
      const values = { filter: filter === 'all' ? '' : filter, footprint: footprint === 'all' ? '' : footprint, sorting: sorting === 'curated' ? '' : sorting };
      Object.entries(stateParams).forEach(([key, name]) => values[key] ? url.searchParams.set(name, values[key]) : url.searchParams.delete(name));
      if (url.href !== location.href) history.replaceState(history.state, '', url.href);
    } catch {}
  }

  const scrollMemoryKey = 'yafico:lighting:return';

  function rememberCollectionPosition() {
    if (preview || inlineProduct) return;
    try {
      sessionStorage.setItem(scrollMemoryKey, JSON.stringify({ path: location.pathname, y: Math.round(window.scrollY), filter, footprint, sorting, at: Date.now() }));
    } catch {}
  }

  function restoreCollectionPosition() {
    if (preview || inlineProduct) return;
    let stored;
    try {
      stored = JSON.parse(sessionStorage.getItem(scrollMemoryKey) || 'null');
      sessionStorage.removeItem(scrollMemoryKey);
    } catch {
      return;
    }
    if (!stored || stored.path !== location.pathname || Date.now() - stored.at > 30 * 60 * 1000) return;
    const navigation = performance.getEntriesByType?.('navigation')?.[0];
    if (navigation && navigation.type !== 'back_forward') return;
    let changed = false;
    if (['all', 'sculptural', 'compact'].includes(stored.filter) && stored.filter !== filter) { filter = stored.filter; changed = true; }
    if (['all', '15', '17', '18'].includes(stored.footprint) && stored.footprint !== footprint) { footprint = stored.footprint; changed = true; }
    if (['curated', 'low', 'high'].includes(stored.sorting) && stored.sorting !== sorting) { sorting = stored.sorting; changed = true; }
    if (changed) {
      root.querySelectorAll('[data-filter]').forEach(filterButton => filterButton.setAttribute('aria-pressed', filterButton.dataset.filter === filter));
      const footprintSelect = root.querySelector('[data-footprint]');
      if (footprintSelect) footprintSelect.value = footprint;
      const sortSelect = root.querySelector('[data-sort]');
      if (sortSelect) sortSelect.value = sorting;
      renderProducts();
    }
    if (Number.isFinite(stored.y) && stored.y > 0) {
      try { history.scrollRestoration = 'manual'; } catch {}
      nextFrame(() => window.scrollTo({ top: stored.y, behavior: 'instant' }));
    }
  }

  function renderProducts() {
    const grid = root.querySelector('#yl-product-grid');
    if (!grid) return;
    let visible = products.filter(product => (filter === 'all' || product.family === filter)
      && (footprint === 'all' || window.YaficoExperience.fitsFootprint(product, Number(footprint))));
    visible = [...visible].sort((first, second) => sorting === 'low' ? first.price - second.price : sorting === 'high' ? second.price - first.price : preferred.indexOf(first.id) - preferred.indexOf(second.id));
    grid.innerHTML = window.YaficoBrand.cards({ ...brandContext(), products: visible }) || `<div class="yl-empty" style="grid-column:1 / -1"><p>${text.searchEmpty}</p>${filter !== 'all' || footprint !== 'all' ? `<button type="button" class="yl-line-link" data-reset-filters>${text.resetFilters}${icons.arrow}</button>` : ''}</div>`;
    const count = root.querySelector('[data-result-count]');
    if (count) count.textContent = `${visible.length} ${text.objects}`;
    const sizeNote = root.querySelector('[data-size-note]');
    if (sizeNote) sizeNote.hidden = footprint === 'all';
    writeCollectionState();
  }

  function resetCollectionFilters(trigger) {
    const restoreFocus = document.activeElement === trigger;
    filter = 'all';
    footprint = 'all';
    root.querySelectorAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', button.dataset.filter === filter));
    const size = root.querySelector('[data-footprint]');
    if (size) size.value = footprint;
    renderProducts();
    if (restoreFocus && !trigger.isConnected && document.activeElement === document.body && !root.querySelector('dialog[open]')) {
      root.querySelector('[data-filter="all"]')?.focus({ preventScroll: true });
    }
  }

  function showDialog(dialog, keepCurrent = false) {
    const focused = document.activeElement;
    dialogFocus.set(dialog, !keepCurrent && focused?.closest('dialog') ? root.querySelector('[data-cart]') : focused);
    if (!keepCurrent) root.querySelectorAll('dialog[open]').forEach(open => open.close());
    dialog.showModal();
    dialog.scrollTop = 0;
    document.body.classList.add('yl-dialog-open');
  }

  function closeDialog(dialog) {
    if (dialog?.id === 'yl-product-dialog') invalidateGallery();
    if (dialog?.id === 'yl-zoom-dialog') zoomRevision += 1;
    dialog.close();
    if (!root.querySelector('dialog[open]')) document.body.classList.remove('yl-dialog-open');
    const focused = dialogFocus.get(dialog);
    if (focused?.isConnected && (!focused.closest('dialog') || focused.closest('dialog').open)) focused.focus({ preventScroll: true });
  }

  function openProduct(modelId, updateUrl = true) {
    invalidateGallery();
    activeProduct = selectedProduct(modelId);
    if (!activeProduct) return;
    const product = activeProduct;
    if (!productEntry) {
      productEntry = pageMetadata();
      productReturnPage = productEntry;
    }
    const destination = productUrl(product);
    updateProductMetadata(product, destination);
    galleryIndex = 0;
    galleryRequestedIndex = 0;
    const purchasable = preview || (config.enabled && product.available && product.variantId && config.kit.available && config.kit.variantId);
    const dialog = root.querySelector('#yl-product-dialog');
    const previousScroll = dialog.open ? dialog.scrollTop : 0;
    const experience = window.YaficoExperience;
    const words = experience.copy[locale];
    const galleryPhoto = photoSource(product, galleryIndex);
    dialog.innerHTML = `
      <button class="yl-icon yl-dialog-close" data-close aria-label="${text.close}">${icons.close}</button>
      <div class="yl-product-layout">
        <div class="yl-gallery" role="group" tabindex="0" aria-label="${escape(product.name)} — ${text.image}">
          <div class="yx-gallery-stage" data-studio="${product.images[galleryIndex] === product.studioImage}">
            <img class="yl-gallery-main" src="${escape(galleryPhoto.src)}" alt="${escape(product.name)} — ${escape(galleryLabel(product, galleryIndex))}"${responsivePhotoAttributes(galleryPhoto)} width="${galleryPhoto.width || 1000}" height="${galleryPhoto.height || 1250}">
            <div class="yx-gallery-controls"><span class="yx-gallery-count" data-gallery-count aria-live="polite" aria-atomic="true">${galleryIndex + 1} / ${product.images.length}</span><div><button data-zoom aria-label="${text.zoom}" class="yl-zoom-trigger">${icons.plus}</button><button data-gallery-step="-1" aria-label="${words.previous}">${icons.arrow}</button><button data-gallery-step="1" aria-label="${words.next}">${icons.arrow}</button></div></div>
          </div>
          <div class="yx-gallery-caption"><span data-gallery-caption>${escape(galleryLabel(product, galleryIndex))}</span><span>${escape(product.name)} / ${product.id}</span></div>
          <div class="yl-thumbnails">${product.images.map((filename, position) => `<button data-image="${position}" aria-label="${escape(galleryLabel(product, position))} — ${position + 1}" aria-pressed="${position === galleryIndex}"><img src="${escape(thumbnail(product, position))}" alt="" width="100" height="125" loading="lazy"></button>`).join('')}</div>
          <p class="yx-gallery-disclaimer">${words.inspiration}</p>
        </div>
        <div class="yl-product-info">
          <p class="yl-eyebrow">${product.family === 'compact' ? text.compact : text.sculptural} / ${product.id}</p><h2 id="yl-product-name">${product.name}</h2><p class="yl-product-subtitle">${escape(product.description[locale])}</p>
          <p class="yl-purchase-label">${locale === 'de' ? 'Gesamtpreis für zwei separate Artikel' : 'Totaalprijs voor twee losse artikelen'}</p><div class="yl-price">${money(product.price)}</div><p class="yl-tax-note">${text.inclusive} · ${policyLink('shipping', text.shipping)}</p><p class="yl-product-detail">${escape(product.detail[locale])}</p>
          ${window.YaficoVariants?.choices(brandContext(), product) || ''}
          ${product.dimensions ? `<div class="yx-product-measure">${escape(product.dimensions)}</div>` : ''}
          <div class="yl-included yl-separate-articles"><p>${text.included}</p><div><span><small>01 / ${locale === 'de' ? 'YAFICO' : 'YAFICO'}</small><strong>${product.name} — ${text.shade}</strong><em>${locale === 'de' ? 'Ohne Lichtquelle' : 'Zonder lichtbron'}</em></span><span>${money(product.shadePrice)}</span></div><div><span><small>02 / LED-KIT</small><strong>${text.kit}</strong><em>${locale === 'de' ? 'Separate USB-Lichtquelle' : 'Afzonderlijke USB-lichtbron'}</em></span><span>${money(config.kit.price)}</span></div><p class="yl-separate-note">${locale === 'de' ? 'Nicht vormontiert. Separat verpackt. Der LED-Kit bleibt deiner Auswahl zugeordnet.' : 'Niet voorgemonteerd. Apart verpakt. De LED-kit blijft aan je selectie gekoppeld.'}</p></div>
          <button class="yl-button yl-add-button" data-add="${product.id}" ${purchasable ? '' : 'disabled'}>${purchasable ? text.add : text.unavailable}${icons.arrow}</button><p class="yl-delivery">${escape(config.leadTime?.[locale] || (preview ? text.previewDelivery : text.availabilityText))}${config.carriers?.[locale] ? `<br>${words.carrierLine} <strong>${escape(config.carriers[locale])}</strong>` : ''}</p><p class="yl-delivery">${policyLink('refund', text.returns)}</p>${experience.payments(brandContext(), 'product')}<p class="yl-component-note">${text.productNote}</p>
          <div class="yl-product-accordions">${product.dimensions || product.material ? `<details><summary>${text.specs}<span>+</span></summary><p>${[product.dimensions, product.material].filter(Boolean).map(value => escape(value)).join('<br>')}</p></details>` : ''}<details><summary>${text.safety}<span>+</span></summary><p>${product.safety?.[locale] ? escape(product.safety[locale]).replace(/\n/g, '<br>') : locale === 'de' ? 'Beachte die Hinweise für Schirm und LED-Kit. Nur entsprechend der jeweiligen Anleitung verwenden; bei Beschädigung nicht weiterverwenden.' : 'Volg de instructies voor de kap en de LED-kit. Gebruik beide alleen volgens de bijbehorende aanwijzingen; gebruik ze niet bij beschadiging.'}</p>${policyLink('safety', locale === 'de' ? 'Sicherheit & CE-Informationen' : 'Veiligheid & CE-informatie')}</details><details><summary>${text.manufacturer}<span>+</span></summary>${window.YaficoExperience.manufacturerInfo(brandContext(), product)}</details></div>
        </div>
      </div>`;
    dialog.insertAdjacentHTML('beforeend', `<div class="yb-product-sticky"><div><span>${escape(product.name)}</span><strong>${money(product.price)}</strong></div><button class="yb-button yb-button-lime" data-add="${product.id}" ${purchasable ? '' : 'disabled'}>${purchasable ? text.add : text.unavailable}<span>${icons.arrow}</span></button></div>`);
    if (!dialog.open) showDialog(dialog);
    else dialog.scrollTop = previousScroll;
    warmGallery();
    if (updateUrl || (!preview && location.hash.startsWith('#model-') && !destination.startsWith('#'))) {
      const currentPath = location.pathname.startsWith('//') ? '/' : location.pathname;
      const target = destination.startsWith('#') ? `${currentPath}${location.search}${destination}` : destination;
      history.replaceState(null, '', target);
    }
  }

  function galleryLabel(product, position) {
    const words = window.YaficoExperience.copy[locale];
    if (product.images[position] === product.studioImage) return words.studio;
    const caption = product.imageCaptions?.[product.images[position]]?.[locale];
    if (caption) return caption;
    const scene = (product.lifestyleImages || []).indexOf(product.images[position]);
    return words.scenes[scene] || (locale === 'de' ? 'Interieur-Inspiration' : 'Interieurinspiratie');
  }

  function activeGallery() {
    return root.querySelector('#yl-product-dialog[open] .yl-gallery') || root.querySelector('.yp-page .yl-gallery') || root.querySelector('.yl-gallery');
  }

  function invalidateGallery() {
    gallerySession += 1;
    galleryRevision += 1;
    galleryWarmRevision += 1;
    zoomRevision += 1;
    galleryRequestedIndex = galleryIndex;
  }

  function assignPhotoSource(photo, source) {
    if (source.srcset) {
      photo.setAttribute('sizes', source.sizes);
      photo.setAttribute('srcset', source.srcset);
    } else {
      photo.removeAttribute('srcset');
      photo.removeAttribute('sizes');
    }
    photo.src = source.src;
  }

  function prepareGalleryPhoto(source, priority = 'low') {
    const key = JSON.stringify([source.src, source.srcset || '', source.sizes || '']);
    const cached = galleryPhotos.get(key);
    if (cached) {
      galleryPhotos.delete(key);
      galleryPhotos.set(key, cached);
      if (priority === 'high') cached.photo.fetchPriority = priority;
      return cached.promise;
    }
    const photo = new window.Image();
    photo.decoding = 'async';
    photo.fetchPriority = priority;
    let resolvePhoto;
    let rejectPhoto;
    let loaded = false;
    const promise = new Promise((resolve, reject) => { resolvePhoto = resolve; rejectPhoto = reject; });
    const entry = { photo, promise };
    galleryPhotos.set(key, entry);
    while (galleryPhotos.size > 8) galleryPhotos.delete(galleryPhotos.keys().next().value);
    photo.onload = async () => {
      if (loaded) return;
      loaded = true;
      try { await photo.decode?.(); } catch {}
      resolvePhoto(photo);
    };
    photo.onerror = () => {
      if (galleryPhotos.get(key) === entry) galleryPhotos.delete(key);
      rejectPhoto(new Error('Gallery image unavailable'));
    };
    assignPhotoSource(photo, source);
    if (photo.complete && photo.naturalWidth > 0) photo.onload();
    return promise;
  }

  function galleryIdle() {
    return new Promise(resolve => {
      if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(resolve, { timeout: 1200 });
      else setTimeout(resolve, 0);
    });
  }

  function warmGallery(ready = false) {
    if (typeof window.Image !== 'function' || !activeProduct) return;
    const product = activeProduct;
    const gallery = activeGallery();
    const photo = gallery?.querySelector('.yl-gallery-main');
    if (!photo) return;
    const session = gallerySession;
    const revision = ++galleryWarmRevision;
    const position = galleryIndex;
    const current = () => gallerySession === session && galleryWarmRevision === revision && activeProduct === product && galleryIndex === position && galleryRequestedIndex === position && activeGallery() === gallery;
    const warm = async () => {
      const connection = window.navigator?.connection;
      const conserve = connection?.saveData || ['slow-2g', '2g'].includes(connection?.effectiveType);
      const count = product.images.length;
      const order = Array.from({ length: count - 1 }, (_, offset) => (position + offset + 1) % count);
      if (!ready && !conserve) await new Promise(resolve => nextFrame(() => nextFrame(resolve)));
      for (const index of conserve ? order.slice(0, 1) : order) {
        // Give the first visible image two paint opportunities before background work.
        // Its next photo then starts without an idle timeout.
        // Subsequent work stays sequential and low priority; data-saving connections wait.
        if (ready || conserve || index !== order[0]) await galleryIdle();
        if (!current()) return;
        try { await prepareGalleryPhoto(photoSource(product, index)); } catch {}
      }
    };
    if (ready || (photo.complete && photo.naturalWidth > 0)) warm();
    else photo.addEventListener?.('load', warm, { once: true });
  }

  async function setGallery(position) {
    if (!activeProduct?.images.length) return false;
    const product = activeProduct;
    const gallery = activeGallery();
    const photo = gallery?.querySelector('.yl-gallery-main');
    if (!photo) return false;
    const session = gallerySession;
    const revision = ++galleryRevision;
    galleryWarmRevision += 1;
    const target = ((position % product.images.length) + product.images.length) % product.images.length;
    galleryRequestedIndex = target;
    const current = () => gallerySession === session && galleryRevision === revision && activeProduct === product && activeGallery() === gallery;
    const source = photoSource(product, target);
    gallery.setAttribute('aria-busy', 'true');
    try {
      if (typeof window.Image === 'function') await prepareGalleryPhoto(source, 'high');
      if (!current()) return false;
      assignPhotoSource(photo, source);
      galleryIndex = target;
      photo.alt = `${activeProduct.name} — ${galleryLabel(activeProduct, galleryIndex)}`;
      gallery.querySelector('.yx-gallery-stage').dataset.studio = String(activeProduct.images[galleryIndex] === activeProduct.studioImage);
      gallery.querySelector('[data-gallery-count]').textContent = `${galleryIndex + 1} / ${activeProduct.images.length}`;
      gallery.querySelector('[data-gallery-caption]').textContent = galleryLabel(activeProduct, galleryIndex);
      gallery.querySelectorAll('[data-image]').forEach(thumbnail => thumbnail.setAttribute('aria-pressed', Number(thumbnail.dataset.image) === galleryIndex));
      warmGallery(true);
      await updateZoom();
      return current();
    } catch {
      if (current()) galleryRequestedIndex = galleryIndex;
      return false;
    } finally {
      if (current()) gallery.removeAttribute('aria-busy');
    }
  }

  let suppressZoomClick = false;

  function zoomMarkup() {
    const words = window.YaficoExperience.copy[locale];
    const source = photoSource(activeProduct, galleryIndex);
    return `<button class="yl-icon yl-dialog-close" data-close aria-label="${text.zoomClose}">${icons.close}</button><div class="yl-zoom-stage" data-zoom-stage data-zoomed="false" data-zoomable="false"><img src="${escape(source.zoomSrc)}" alt="${escape(activeProduct.name)} — ${escape(galleryLabel(activeProduct, galleryIndex))}"${source.zoomWidth ? ` width="${source.zoomWidth}" height="${source.zoomHeight}"` : ''} decoding="async"></div><div class="yl-zoom-bar"><button type="button" data-zoom-step="-1" aria-label="${words.previous}">${icons.arrow}</button><span data-zoom-count>${galleryIndex + 1} / ${activeProduct.images.length}</span><button type="button" data-zoom-step="1" aria-label="${words.next}">${icons.arrow}</button></div><p class="yl-zoom-hint" data-zoom-hint hidden>${text.zoomHint}</p>`;
  }

  function configureZoom(dialog) {
    const photo = dialog.querySelector('img');
    const stage = dialog.querySelector('[data-zoom-stage]');
    function updateBounds() {
      if (!dialog.open || !photo.naturalWidth || !photo.naturalHeight) return;
      const pixelRatio = Math.max(1, Number(window.devicePixelRatio) || 1);
      const fittedWidth = Math.min(photo.naturalWidth, stage.clientWidth, stage.clientHeight * photo.naturalWidth / photo.naturalHeight);
      if (!fittedWidth) return;
      const zoomWidth = Math.max(fittedWidth, Math.min(photo.naturalWidth / pixelRatio, fittedWidth * 2));
      const canZoom = zoomWidth > fittedWidth * 1.03;
      stage.style.setProperty('--yl-zoom-width', `${Math.round(zoomWidth)}px`);
      stage.dataset.zoomable = String(canZoom);
      dialog.querySelector('[data-zoom-hint]').hidden = !canZoom;
      if (!canZoom) stage.dataset.zoomed = 'false';
    }
    photo.onload = updateBounds;
    if (photo.complete) nextFrame(updateBounds);
  }

  function openZoom() {
    const dialog = root.querySelector('#yl-zoom-dialog');
    if (!dialog || !activeProduct) return;
    zoomRevision += 1;
    dialog.innerHTML = zoomMarkup();
    showDialog(dialog, true);
    configureZoom(dialog);
  }

  async function updateZoom() {
    const dialog = root.querySelector('#yl-zoom-dialog');
    if (!dialog?.open || !activeProduct) return;
    const product = activeProduct;
    const position = galleryIndex;
    const revision = ++zoomRevision;
    const galleryRequest = galleryRevision;
    const photo = dialog.querySelector('img');
    const source = { src: photoSource(product, position).zoomSrc };
    try {
      if (typeof window.Image === 'function') await prepareGalleryPhoto(source, 'high');
      if (!dialog.open || zoomRevision !== revision || galleryRevision !== galleryRequest || activeProduct !== product || galleryIndex !== position || root.querySelector('#yl-zoom-dialog') !== dialog) return;
    } catch { return; }
    photo.src = source.src;
    photo.alt = `${activeProduct.name} — ${galleryLabel(activeProduct, galleryIndex)}`;
    dialog.querySelector('[data-zoom-count]').textContent = `${galleryIndex + 1} / ${activeProduct.images.length}`;
    const stage = dialog.querySelector('[data-zoom-stage]');
    stage.dataset.zoomed = 'false';
    stage.dataset.zoomable = 'false';
    stage.scrollTo(0, 0);
    configureZoom(dialog);
  }

  function cartKitInfo() {
    const german = locale === 'de';
    const summary = german ? 'Warum wird das LED-Kit separat aufgeführt?' : 'Waarom staat de LED-kit apart?';
    const purpose = german
      ? 'Das LED-Kit ist die separate USB-Lichtquelle, die deinen Lampenschirm zum Leuchten bringt. Bei der Auswahl eines Lichtobjekts wird das passende Kit automatisch hinzugefügt.'
      : 'De LED-kit is de losse USB-lichtbron die je lampenkap laat oplichten. We voegen de passende kit automatisch toe wanneer je een lichtobject kiest.';
    const pricing = german
      ? '<strong>Keine zusätzlichen Kosten über den angezeigten Gesamtpreis hinaus.</strong> Lampenschirm und LED-Kit sind zwei separate Artikel mit jeweils eigenem Preis. Zusammen ergeben sie den beim Lichtobjekt angezeigten Gesamtpreis.'
      : '<strong>Geen extra kosten bovenop de getoonde totaalprijs.</strong> Je ziet de lampenkap en LED-kit als twee losse artikelen met elk een eigen prijs. Samen vormen ze de totaalprijs die je bij het lichtobject zag.';
    const delivery = german
      ? 'Beide Artikel werden separat verpackt und nicht vormontiert geliefert. Ein USB-Netzadapter ist nicht enthalten.'
      : 'Beide artikelen worden apart verpakt en niet voorgemonteerd geleverd. Een USB-netadapter is niet inbegrepen.';
    return `<details class="yl-cart-kit-info"><summary><span class="yl-cart-info-icon" aria-hidden="true">i</span><span>${summary}</span><span class="yl-cart-info-chevron" aria-hidden="true">+</span></summary><div><p>${purpose}</p><p>${pricing}</p><p>${delivery}</p></div></details>`;
  }

  function cartPairs() {
    const groups = [];
    const singles = [];
    cartState.items.forEach(item => {
      const pair = item.properties?._yafico_pair;
      if (!pair) {
        singles.push(item);
        return;
      }
      let group = groups.find(candidate => candidate.id === pair);
      if (!group) {
        group = { id: pair, items: [] };
        groups.push(group);
      }
      group.items.push(item);
    });
    return { groups, singles };
  }

  function hasIncompleteCartPairs(groups) {
    return groups.some(group => {
      let shades = 0;
      let lights = 0;
      group.items.forEach(item => {
        if (item.properties?._yafico_role === 'shade') shades += item.quantity;
        if (item.properties?._yafico_role === 'light') lights += item.quantity;
      });
      return !Number.isSafeInteger(shades) || shades < 1
        || !Number.isSafeInteger(lights) || lights < 1 || shades !== lights;
    });
  }

  function lineTotal(item) {
    return item.final_line_price ?? item.line_price ?? item.price * item.quantity;
  }

  function cartLine(item) {
    const isKit = item.properties?._yafico_role === 'light' || Boolean(config.kit.variantId && String(item.variant_id) === String(config.kit.variantId));
    const title = isKit ? text.kit : item.product_title || item.title || '';
    const itemImage = typeof item.image === 'string' ? item.image : item.featured_image?.url;
    const variantTitle = !isKit && item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    return `<article class="yl-cart-item" data-cart-line="${escape(item.key)}">${itemImage ? `<img src="${escape(itemImage)}" alt="${escape(title)}" width="80" height="90" loading="lazy">` : ''}<div class="yl-cart-item-copy"><h3>${escape(title)}</h3>${variantTitle ? `<p class="yl-cart-color">${escape(variantTitle)}</p>` : ''}<div class="yl-cart-item-meta"><span>${text.quantity}: ${item.quantity}</span><strong>${money(lineTotal(item))}</strong></div><button class="yl-remove" data-remove-line="${escape(item.key)}" aria-label="${text.remove} — ${escape(title)}">${text.remove}</button></div></article>`;
  }

  function cartDisplayCount() {
    const { groups, singles } = cartPairs();
    return groups.reduce((count, group) => {
      const shade = group.items.find(item => item.properties?._yafico_role === 'shade');
      return count + (shade ? shade.quantity : group.items[0].quantity);
    }, 0) + singles.reduce((count, item) => count + item.quantity, 0);
  }

  function captureCartFocus(button) {
    const dialog = root.querySelector('#yl-cart-dialog');
    if (!dialog?.open || document.activeElement !== button || !dialog.contains(button)) return null;
    const rows = [...dialog.querySelectorAll('[data-cart-pair], .yl-cart-item')];
    const snapshot = {
      dialog, trigger: button, pair: button.dataset.qtyPair || button.dataset.remove || '',
      line: button.dataset.removeLine || '', delta: button.dataset.qtyDelta || '',
      row: rows.findIndex(row => row.contains(button)), moved: false
    };
    snapshot.onFocus = event => {
      if (event.target !== button && event.target !== document.body) snapshot.moved = true;
    };
    document.addEventListener('focusin', snapshot.onFocus, true);
    return snapshot;
  }

  function restoreCartFocus(snapshot) {
    if (!snapshot) return;
    document.removeEventListener('focusin', snapshot.onFocus, true);
    const { dialog, trigger } = snapshot;
    const active = document.activeElement;
    if (snapshot.moved || !dialog.open || dialog !== root.querySelector('#yl-cart-dialog')
      || (active && active !== document.body && active !== trigger && active.isConnected)) return;
    const controls = [...dialog.querySelectorAll('[data-qty-pair], [data-remove], [data-remove-line]')];
    const enabled = control => !control.disabled;
    let target = snapshot.delta
      ? controls.find(control => enabled(control) && control.dataset.qtyPair === snapshot.pair && control.dataset.qtyDelta === snapshot.delta)
        || controls.find(control => enabled(control) && control.dataset.qtyPair === snapshot.pair)
      : controls.find(control => enabled(control) && (snapshot.line ? control.dataset.removeLine === snapshot.line : control.dataset.remove === snapshot.pair));
    if (!target && snapshot.row >= 0) {
      const rows = [...dialog.querySelectorAll('[data-cart-pair], .yl-cart-item')];
      const row = rows[Math.min(snapshot.row, rows.length - 1)];
      target = row?.querySelector('[data-remove]:not(:disabled), [data-remove-line]:not(:disabled)');
    }
    target = target || dialog.querySelector('[data-continue]:not(:disabled)')
      || dialog.querySelector('.yl-cart-bottom a.yl-button') || dialog.querySelector('[data-close]:not(:disabled)');
    target?.focus({ preventScroll: true });
  }

  function renderCart() {
    const dialog = root.querySelector('#yl-cart-dialog');
    const { groups, singles } = cartPairs();
    const moduleIcon = '<svg viewBox="0 0 80 80" fill="none" stroke="currentColor" stroke-width="1.4" aria-hidden="true"><circle cx="37" cy="32" r="19"/><circle cx="37" cy="32" r="8"/><path d="M37 7v-4M37 61v-5M12 32H7M67 32h-5M19 14l-4-4M55 14l4-4M18 50l-4 4M56 50l4 4M37 51v14c0 5 5 7 10 7h7"/><rect x="54" y="67" width="13" height="10" rx="1"/><path d="M67 70h5v4h-5"/></svg>';
    const pairMarkup = groups.map(group => {
      const shade = group.items.find(item => item.properties?._yafico_role === 'shade');
      const light = group.items.find(item => item.properties?._yafico_role === 'light');
      if (!shade || !light) return group.items.map(item => cartLine(item)).join('');
      const base = products.find(candidate => String(candidate.variantId) === String(shade.variant_id) || candidate.colorChoices?.some(choice => String(choice.variantId) === String(shade.variant_id)) || shade.product_title?.startsWith(candidate.name));
      const product = window.YaficoVariants?.forCart(brandContext(), base, shade) || base;
      const name = product ? product.name : String(shade.product_title || '').replace(/\s[—-]\s.*$/, '');
      const itemImage = product ? image(product) : typeof shade.image === 'string' ? shade.image : shade.featured_image?.url;
      const lightImage = config.kit.image ? asset(config.kit.image) : typeof light.image === 'string' ? light.image : light.featured_image?.url;
      const quantity = shade.quantity;
      const colorLabel = product?.colorLabel || (shade.variant_title !== 'Default Title' ? shade.variant_title : '');
      return `<article class="yl-cart-pair" data-cart-pair="${escape(group.id)}" aria-label="${escape(name)} — ${text.pairTitle}"><div class="yl-cart-component" data-cart-role="shade" data-cart-line="${escape(shade.key)}">${itemImage ? `<img src="${escape(itemImage)}" alt="${escape(name)} — ${text.shade}" width="80" height="90" loading="lazy">` : ''}<div class="yl-cart-item-copy"><p class="yl-cart-item-type">01 / YAFICO</p><h3>${escape(name)} — ${text.shade}</h3>${colorLabel ? `<p class="yl-cart-color">${escape(colorLabel)}</p>` : ''}<p class="yl-cart-component-detail">${text.cartShadeDetail}</p><div class="yl-cart-item-meta"><span>${text.quantity}: ${shade.quantity}</span><strong>${money(lineTotal(shade))}</strong></div></div></div><div class="yl-cart-component" data-cart-role="light" data-cart-line="${escape(light.key)}">${lightImage ? `<img src="${escape(lightImage)}" alt="${text.kit}" width="80" height="90" loading="lazy">` : `<div class="yl-cart-module">${moduleIcon}<span>${text.kit}</span></div>`}<div class="yl-cart-item-copy"><p class="yl-cart-item-type">02 / LED-KIT</p><h3>${text.kit}</h3><p class="yl-cart-component-detail">${text.cartKitDetail}</p><div class="yl-cart-item-meta"><span>${text.quantity}: ${light.quantity}</span><strong>${money(lineTotal(light))}</strong></div></div></div><div class="yl-cart-pair-actions"><div><span class="yl-cart-pair-quantity-label">${text.cartPairQuantity}</span><div class="yl-qty" role="group" aria-label="${text.cartPairQuantity}"><button type="button" data-qty-pair="${escape(group.id)}" data-qty-delta="-1" aria-label="${text.decrease}">−</button><span aria-live="polite">${quantity}</span><button type="button" data-qty-pair="${escape(group.id)}" data-qty-delta="1" aria-label="${text.increase}" ${quantity >= 10 ? 'disabled' : ''}>+</button></div></div><button class="yl-remove" data-remove="${escape(group.id)}" aria-label="${text.remove} — ${escape(name)} — ${text.pairTitle}">${text.remove}</button></div></article>`;
    }).join('');
    const singleMarkup = singles.map(item => cartLine(item)).join('');
    const hasItems = groups.length > 0 || singles.length > 0;
    const checkoutMarkup = preview
      ? `<button class="yl-button" data-preview-checkout>${text.checkout}${icons.arrow}</button>`
      : hasIncompleteCartPairs(groups)
        ? `<p class="yl-cart-explanation" id="yl-cart-pair-warning" data-cart-pair-warning role="alert">${text.cartPairIncomplete}</p><button class="yl-button" data-cart-pair-blocked disabled aria-describedby="yl-cart-pair-warning">${text.checkout}${icons.arrow}</button>`
        : `<a class="yl-button" href="${escape(config.checkoutUrl || `${(config.root || '/').replace(/\/$/, '')}/checkout`)}">${text.checkout}${icons.arrow}</a>`;
    const delivery = deliveryEstimate();
    dialog.innerHTML = `<div class="yl-drawer-header"><div><p class="yl-eyebrow">YAFICO LIGHTING</p><h2 id="yl-cart-title">${text.cartTitle}</h2></div><button class="yl-icon" data-close aria-label="${text.close}">${icons.close}</button></div><div class="yl-cart-items">${hasItems ? pairMarkup + singleMarkup : `<div class="yl-empty"><p>${text.empty}</p><button class="yl-line-link" data-continue>${text.continue}${icons.arrow}</button></div>`}</div><div class="yl-cart-bottom">${hasItems ? `${groups.length ? `<p class="yl-cart-explanation">${text.cartTwoItems}</p>${cartKitInfo()}` : ''}<div class="yl-total"><span>${text.total}</span><strong>${money(cartState.total_price)}</strong></div><p class="yl-tax-note">${text.cartNote}</p><p class="yl-cart-delivery"><span>${text.deliveryLabel}</span><strong>${escape(delivery.text)}</strong></p>${checkoutMarkup}<button class="yl-cart-continue" data-continue>${text.continueShopping}</button><p class="yl-payment-note">${text.paymentNote}</p>` : ''}</div>`;
    root.querySelectorAll('[data-cart-count]').forEach(element => { element.textContent = cartDisplayCount(); });
  }

  async function openCart() {
    try {
      cartState = await cart.read();
      renderCart();
      showDialog(root.querySelector('#yl-cart-dialog'));
    } catch (error) {
      console.error(error);
      toast(text.error);
    }
  }

  function toast(message) {
    const element = root.querySelector('.yl-toast');
    element.textContent = message;
    element.classList.add('yl-toast-visible');
    clearTimeout(toast.timeout);
    toast.timeout = setTimeout(() => element.classList.remove('yl-toast-visible'), 6000);
  }

  function showInfo(title, content) {
    const dialog = root.querySelector('#yl-info-dialog');
    dialog.innerHTML = `<button class="yl-icon yl-dialog-close" data-close aria-label="${text.close}">${icons.close}</button><p class="yl-eyebrow">YAFICO LIGHTING</p><h2 id="yl-info-title">${title}</h2><div class="yl-info-body">${content}</div>`;
    showDialog(dialog, true);
  }

  function contactDetails() {
    const cro = config.cro || {};
    const german = locale === 'de';
    const phone = String(cro.phone || '').trim();
    const whatsapp = String(cro.whatsapp || '').replace(/[^\d]/g, '');
    const rows = [[text.contactEmail, `<a href="mailto:${escape(config.contactEmail)}">${escape(config.contactEmail)}</a>`]];
    if (phone) rows.push([text.contactPhone, `<a href="tel:${escape(phone.replace(/[^\d+]/g, ''))}">${escape(phone)}</a>`]);
    if (whatsapp) rows.push(['WhatsApp', `<a href="https://wa.me/${escape(whatsapp)}" target="_blank" rel="noopener noreferrer">+${escape(whatsapp)}</a>`]);
    rows.push([text.contactAddress, `Yafico VOF<br>Beugstraat 118<br>3192 GA Hoogvliet Rotterdam<br>${german ? 'Niederlande' : 'Nederland'}`]);
    const response = String(cro.responseTime?.[locale] || '').trim();
    return `<dl class="yl-contact-list">${rows.map(([label, value]) => `<div><dt>${escape(label)}</dt><dd>${value}</dd></div>`).join('')}</dl>${response ? `<p class="yl-contact-response">${escape(response)}</p>` : ''}`;
  }

  function imprintContent() {
    const german = locale === 'de';
    const cro = config.cro || {};
    const phone = String(cro.phone || '').trim();
    return `<p><strong>Yafico VOF</strong><br>Beugstraat 118<br>3192 GA Hoogvliet Rotterdam<br>${german ? 'Niederlande' : 'Nederland'}</p><p>${german ? 'Vertretungsberechtigte Gesellschafter' : 'Vennoten'}: Yavar Mozahari, Ricardo Ausems</p><p>${german ? 'E-Mail' : 'E-mail'}: <a href="mailto:${escape(config.contactEmail)}">${escape(config.contactEmail)}</a>${phone ? `<br>${german ? 'Telefon' : 'Telefoon'}: <a href="tel:${escape(phone.replace(/[^\d+]/g, ''))}">${escape(phone)}</a>` : ''}</p><p>${german ? 'Handelsregister: Kamer van Koophandel (NL), Nr. 98382616' : 'KvK-nummer: 98382616'}<br>${german ? 'Umsatzsteuer-Identifikationsnummer: NL868469282B01' : 'Btw-identificatienummer: NL868469282B01'}</p><p>${german ? 'Beschwerden zu einer Bestellung? Sende uns deine Bestellnummer und eine Beschreibung des Problems per E-Mail:' : 'Een klacht over je bestelling? Mail ons je bestelnummer en een beschrijving van het probleem:'} <a href="mailto:${escape(config.contactEmail)}">${escape(config.contactEmail)}</a>.</p>${german ? '<p>Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.</p><p>Verantwortlich für den Inhalt: Yafico VOF, Anschrift wie oben.</p>' : ''}`;
  }

  function serviceInfo(kind) {
    const german = locale === 'de';
    const contact = `<a href="mailto:${escape(config.contactEmail)}">${escape(config.contactEmail)}</a>`;
    const withdrawal = config.policies?.withdrawal ? `<p>${policyLink('withdrawal', german ? 'Vertrag widerrufen' : 'Koop ongedaan maken')}</p>` : '';
    const safetyDetails = config.policies?.safety ? `<p>${policyLink('safety', german ? 'Alle Sicherheits- und Produktinformationen' : 'Alle veiligheids- en productinformatie')}</p>` : '';
    const content = {
      contact: [text.contactTitle, `<p>${text.contactIntro}</p>${contactDetails()}`],
      warranty: [text.faq6, `<p>${text.faq6Text}</p><p>${contact}</p>`],
      shipping: [text.shippingPolicy, `<p>${text.faq4Text}</p><p>${text.faq2Text}</p><p>${german ? 'Fragen zu deiner Sendung? Nenne uns deine Bestellnummer:' : 'Een vraag over je zending? Mail ons met je bestelnummer:'} ${contact}.</p>`],
      refund: [text.returns, `<p>${text.faq5Text}</p>${withdrawal}<p>${german ? 'Du kannst den Widerruf auch per E-Mail mit deiner Bestellnummer und den betreffenden Artikeln erklären. Eine Begründung ist nicht erforderlich. Nach dem Widerruf hast du 14 Tage Zeit, die Artikel zurückzusenden. Die Rücksendekosten trägst du selbst; die vollständigen Rückgabeinformationen findest du in unseren Rückgabebedingungen.' : 'Je kunt de koop ook per e-mail ongedaan maken met je bestelnummer en de betreffende artikelen. Een reden opgeven is niet verplicht. Na je herroeping heb je 14 dagen om de artikelen terug te sturen. De retourkosten betaal je zelf; de volledige retourinformatie staat in ons retourbeleid.'}</p><p>${contact}</p>`],
      components: [german ? 'Zwei separate Artikel' : 'Twee losse artikelen', `<p>${german ? 'Du kaufst einen Yafico-Lampenschirm ohne Lichtquelle und ein separates LED-Kit. Die gemeinsame Auswahl fügt beide Produkte mit jeweils eigenem Preis hinzu. Entfernst du die Auswahl beim Lampenschirm, werden beide Artikel entfernt.' : 'Je koopt een Yafico-lampenkap zonder lichtbron en een losse LED-kit. De gezamenlijke selectie voegt beide producten met hun eigen prijs toe. Verwijder je de selectie bij de kap, dan worden beide artikelen verwijderd.'}</p><p>${german ? 'Wir liefern die Artikel separat verpackt und nicht vormontiert. Das LED-Kit ist ein eigenständiger Artikel. Ein USB-Netzadapter ist nicht enthalten. Verwende die Artikel nur entsprechend der jeweiligen Anleitung.' : 'We leveren de artikelen apart verpakt en niet voorgemonteerd. De LED-kit is een zelfstandig artikel. Een USB-netadapter is niet inbegrepen. Gebruik de artikelen uitsluitend volgens de bijbehorende instructies.'}</p>`],
      safety: [german ? 'Sicherheit & CE' : 'Veiligheid & CE', `<p>${german ? 'Du erhältst zwei separate Artikel: einen passiven, nicht elektrischen Lampenschirm und das elektrische LED-Kit MH001. CE-Angaben und die EU-Konformitätserklärung beziehen sich auf das darin bezeichnete elektrische Produkt.' : 'Je ontvangt twee losse artikelen: een passieve, niet-elektrische lampenkap en de elektrische LED-kit MH001. CE-informatie en de EU-conformiteitsverklaring hebben betrekking op het daarin genoemde elektrische product.'}</p><p>${german ? 'Verwende das 5-V-USB-LED-Kit (3 W) nur in trockenen Innenräumen und entsprechend den Anleitungen beider Artikel. Halte die Teile von Wärmequellen fern. Vor Reinigung ausschalten, vom Strom trennen und abkühlen lassen. Bei Schäden, ungewöhnlichem Geruch oder Überhitzung nicht weiterverwenden.' : 'Gebruik de 5V USB-LED-kit (3 W) alleen in droge binnenruimten en volgens de instructies van beide artikelen. Houd de onderdelen uit de buurt van warmtebronnen. Schakel vóór het schoonmaken uit, koppel de voeding los en laat afkoelen. Gebruik de onderdelen niet verder bij schade, een ongebruikelijke geur of oververhitting.'}</p>${safetyDetails}<p>${german ? 'Fragen zum Produkt oder zur Dokumentation?' : 'Een vraag over het product of de documentatie?'} ${contact}.</p>`],
      care: [german ? 'Verwendung & Pflege' : 'Gebruik & onderhoud', `<p>${german ? 'Vor dem Reinigen immer vom Strom trennen und abkühlen lassen. Den Schirm vorsichtig mit einem weichen, trockenen Tuch entstauben. Keine Flüssigkeiten in das LED-Modul oder seine Anschlüsse gelangen lassen.' : 'Koppel vóór het schoonmaken de voeding los en laat de onderdelen afkoelen. Stof de kap voorzichtig af met een zachte, droge doek. Laat geen vloeistof in de LED-module of aansluitingen komen.'}</p><p>${german ? 'Beachte stets die modellspezifischen Hinweise und die Anleitung von Bambu Lab. Verwende keine andere Lichtquelle, ohne die Eignung für den jeweiligen Schirm zu prüfen. Bewahre Verpackung, Kennzeichnung und Anleitungen auf.' : 'Volg altijd de modelspecifieke aanwijzingen en de Bambu Lab-handleiding. Gebruik geen andere lichtbron zonder de geschiktheid voor de betreffende kap te controleren. Bewaar de verpakking, etiketten en instructies.'}</p>`],
      terms: [german ? 'Bestellung & Bedingungen' : 'Bestellen & voorwaarden', `<p>Yafico VOF · Beugstraat 118 · 3192 GA Hoogvliet Rotterdam · ${german ? 'Niederlande' : 'Nederland'}. KvK 98382616 · BTW NL868469282B01.</p><p>${german ? 'Die angezeigten Preise verstehen sich inklusive MwSt. und Versand nach Deutschland und in die Niederlande. Bei der gemeinsamen Auswahl von Schirm und LED-Kit werden zwei separate Produkte mit eigenem Preis bestellt. Prüfe Artikel, Mengen und Gesamtpreis vor Abschluss deiner Bestellung.' : 'De getoonde prijzen zijn inclusief btw en verzending naar Nederland en Duitsland. Bij de gezamenlijke selectie van een kap en LED-kit bestel je twee afzonderlijke producten met een eigen prijs. Controleer de artikelen, aantallen en totaalprijs vóór het afronden van je bestelling.'}</p><p>${text.faq4Text}</p><p>${text.faq5Text}</p><p>${german ? 'Fragen zu einer Bestellung oder den Bedingungen?' : 'Vragen over je bestelling of de voorwaarden?'} ${contact}.</p>`],
      privacy: [text.privacy, `<p>${german ? 'Für deine Bestellung und die Beantwortung deiner Nachricht benötigt Yafico die von dir übermittelten Kontakt- und Bestelldaten. Zahlungen werden über Shopify und die gewählte Zahlungsart abgewickelt.' : 'Voor je bestelling en het beantwoorden van je bericht gebruikt Yafico de contact- en bestelgegevens die je verstrekt. Betalingen worden via Shopify en de gekozen betaalmethode afgehandeld.'}</p><p>${german ? 'Wenn du Fragen zu deinen personenbezogenen Daten hast oder deine Datenschutzrechte ausüben möchtest, kontaktiere uns:' : 'Wil je iets weten over je persoonsgegevens of je privacyrechten uitoefenen? Neem contact met ons op:'} ${contact}.</p>`],
      cookies: [german ? 'Cookies & lokale Speicherung' : 'Cookies & lokale opslag', `<p>${german ? 'Der Warenkorb verwendet eine lokale Speicherung, damit deine Auswahl beim erneuten Öffnen erhalten bleibt. In deinem Browser kannst du gespeicherte Website-Daten verwalten oder löschen; dadurch kann auch dein Warenkorb geleert werden.' : 'De winkelwagen gebruikt lokale opslag om je selectie te bewaren wanneer je de pagina opnieuw opent. Je kunt opgeslagen websitegegevens in je browser beheren of verwijderen; daardoor kan ook je winkelmand worden geleegd.'}</p><p>${german ? 'Fragen zur Datennutzung im Shop?' : 'Vragen over het gebruik van gegevens in de winkel?'} ${contact}.</p>`]
    };
    return content[kind] || [text.contact, `<p>${contact}</p>`];
  }

  function duoSelection() {
    return ['first', 'second'].map(position => {
      const model = root.querySelector(`[data-duo-model="${position}"]`);
      const variant = root.querySelector(`[data-duo-variant="${position}"]`);
      return model ? selectedProduct(model.value, variant?.value) : null;
    });
  }

  function duoPurchasable(selected) {
    return selected.length === 2 && selected.every(Boolean)
      && (preview || (config.enabled === true && config.kit?.available === true && config.kit.variantId
        && selected.every(product => product.available === true && product.variantId)));
  }

  function renderDuoVariant(position) {
    if (!['first', 'second'].includes(position)) return;
    const container = root.querySelector(`[data-duo-variant-field="${position}"]`);
    const model = root.querySelector(`[data-duo-model="${position}"]`);
    if (!container || !model) return;
    const product = selectedProduct(model.value);
    const choices = product?.colorChoices || [];
    container.innerHTML = choices.length > 1 ? `<label for="yl-duo-${position}-variant">${locale === 'de' ? 'Ausführung' : 'Uitvoering'}<select id="yl-duo-${position}-variant" data-duo-variant="${position}">${choices.map(choice => `<option value="${escape(choice.key)}" ${choice.key === product.colorKey ? 'selected' : ''}>${escape(choice.key === product.colorKey ? product.colorLabel : choice.key === 'natural-amber' && locale === 'de' ? 'Orange' : choice.label)} — ${money(choice.price + config.kit.price)}${choice.available ? '' : ` — ${text.unavailable}`}</option>`).join('')}</select></label>` : '';
  }

  function openDuo() {
    const dialog = root.querySelector('#yl-duo-dialog');
    const options = selected => products.map(product => `<option value="${product.id}" ${product.id === selected ? 'selected' : ''}>${escape(product.name)}${product.colorChoices?.length > 1 ? '' : ` — ${money(product.price)}`}</option>`).join('');
    dialog.innerHTML = `<button class="yl-icon yl-dialog-close" data-close aria-label="${text.close}">${icons.close}</button><p class="yl-eyebrow">${text.duoEyebrow}</p><h2 id="yl-duo-title">${text.duoHeading}</h2><div class="yl-duo-selects"><div><label for="yl-duo-first-model">${text.first}<select id="yl-duo-first-model" data-duo-model="first">${options('03')}</select></label><div data-duo-variant-field="first"></div></div><div><label for="yl-duo-second-model">${text.second}<select id="yl-duo-second-model" data-duo-model="second">${options('05')}</select></label><div data-duo-variant-field="second"></div></div></div><div class="yl-duo-preview" data-duo-preview aria-live="polite" aria-atomic="true"></div><p class="yl-component-note" data-duo-selection></p><p class="yl-component-note">${text.duoNote}</p><button class="yl-button" data-duo-add>${text.duoAdd}${icons.arrow}</button>`;
    renderDuoVariant('first');
    renderDuoVariant('second');
    updateDuo();
    showDialog(dialog);
  }

  function updateDuo() {
    const selected = duoSelection();
    const valid = selected.every(Boolean);
    const label = product => [product.name, product.colorLabel].filter(Boolean).join(' — ');
    root.querySelector('[data-duo-preview]').innerHTML = valid ? selected.map(product => `<img src="${escape(image(product))}" alt="${escape(label(product))}" width="200" height="200">`).join('') + `<div class="yl-total"><span>${text.total}</span><strong>${money(selected.reduce((sum, product) => sum + product.price, 0))}</strong></div>` : '';
    root.querySelector('[data-duo-selection]').textContent = valid ? selected.map(label).join(' + ') : text.unavailable;
    const purchasable = duoPurchasable(selected);
    const button = root.querySelector('[data-duo-add]');
    button.disabled = busy || !purchasable;
    if (!busy) button.innerHTML = `${purchasable ? text.duoAdd : text.unavailable}${icons.arrow}`;
  }

  async function addProduct(modelId, button) {
    if (busy) return;
    busy = true;
    const priorLabel = button.innerHTML;
    button.disabled = true;
    button.textContent = text.adding;
    try {
      cartState = await cart.add(activeProduct?.id === modelId ? activeProduct : selectedProduct(modelId));
      await openCart();
    } catch (error) {
      console.error(error);
      toast(text.error);
    } finally {
      busy = false;
      button.disabled = false;
      button.innerHTML = priorLabel;
    }
  }

  async function addDuo(button) {
    if (busy) return;
    const selected = duoSelection();
    if (!duoPurchasable(selected)) return updateDuo();
    busy = true;
    button.disabled = true;
    button.textContent = text.adding;
    const controls = [...root.querySelectorAll('[data-duo-model], [data-duo-variant]')];
    controls.forEach(control => { control.disabled = true; });
    let added = 0;
    try {
      for (const product of selected) {
        cartState = await cart.add(product);
        added += 1;
      }
      await openCart();
    } catch (error) {
      console.error(error);
      await openCart();
      toast(added ? text.duoPartial : text.error);
    } finally {
      busy = false;
      controls.forEach(control => { control.disabled = false; });
      button.innerHTML = `${text.duoAdd}${icons.arrow}`;
      updateDuo();
    }
  }

  function normalizeBrandCountry() {
    if (preview || config.hostRouting !== true) return false;
    const current = new URL(location.href);
    const homeCountry = { 'lighting.yafico.nl': 'NL', 'leuchten.yafico.de': 'DE' }[current.hostname];
    const countryCode = String(config.countryCode || '').toUpperCase();
    if (!homeCountry || !countryCode) return false;
    const marker = '_yl_country';
    if (['NL', 'DE'].includes(countryCode)) {
      if (current.searchParams.has(marker)) {
        current.searchParams.delete(marker);
        history.replaceState(null, '', `${current.pathname}${current.search}${current.hash}`);
      }
      return false;
    }
    if (current.searchParams.get(marker) === homeCountry) return false;
    const form = document.getElementById('LightingLocalizationForm');
    const countryInput = form?.querySelector('[name="country_code"]');
    const returnInputs = form ? [...form.querySelectorAll('[name="return_to"]')] : [];
    if (!countryInput || !returnInputs.length) return false;
    if (current.pathname.startsWith('//')) current.pathname = '/';
    current.searchParams.set(marker, homeCountry);
    countryInput.value = homeCountry;
    returnInputs.forEach(input => { input.value = `${current.pathname}${current.search}${current.hash}`; });
    form.submit();
    return true;
  }

  function brandLanguageUrl(language) {
    const hosts = { nl: 'lighting.yafico.nl', de: 'leuchten.yafico.de' };
    const current = new URL(location.href);
    if (config.hostRouting !== true || !Object.values(hosts).includes(current.hostname) || !hosts[language]) return null;
    let pathname = current.pathname;
    const localeRoot = String(config.root || '/').replace(/\/+$/, '');
    if (/^\/[a-z]{2}(?:-[a-z]{2})?$/i.test(localeRoot) && (pathname === localeRoot || pathname.startsWith(`${localeRoot}/`))) {
      pathname = pathname.slice(localeRoot.length) || '/';
    }
    let decodedPath;
    try {
      decodedPath = decodeURIComponent(pathname);
    } catch {
      decodedPath = '';
    }
    const publicPath = /^\/(?:$|cart\/?$|(?:products|collections|pages|policies)(?:\/[^/]+)*\/?)$/.test(pathname);
    const safePath = decodedPath && !/[\\\u0000-\u001f\u007f]/.test(decodedPath)
      && !decodedPath.includes('//') && !/(?:^|\/)\.{1,2}(?:\/|$)/.test(decodedPath)
      && !/%(?:2f|5c)/i.test(pathname + decodedPath);
    const target = new URL(`https://${hosts[language]}/`);
    const draft = current.searchParams.get('preview_theme_id');
    if (config.productPages === true && /^\d+$/.test(draft || '')) target.searchParams.set('preview_theme_id', draft);
    if (activeProduct && /^(?:0[1-9]|1\d|20)$/.test(activeProduct.id)) {
      if (activeProduct.colorKey && /^[1-9]\d*$/.test(String(activeProduct.variantId || ''))) {
        target.hash = `model-${activeProduct.id}`;
        target.searchParams.set('variant', activeProduct.variantId);
        return target.href;
      }
      target.hash = `model-${activeProduct.id}`;
      return target.href;
    }
    if (publicPath && safePath) target.pathname = pathname;
    const variant = current.searchParams.get('variant');
    if (/\/products\//.test(target.pathname) && /^[1-9]\d*$/.test(variant || '')) target.searchParams.set('variant', variant);
    if (/^#model-(?:0[1-9]|1\d|20)$/.test(current.hash)) target.hash = current.hash;
    return target.href;
  }

  async function changeLanguage(language) {
    if (language === locale) return;
    if (!preview) {
      const destination = brandLanguageUrl(language);
      if (destination) {
        location.href = destination;
        return;
      }
      const localizationForm = document.getElementById('LightingLocalizationForm');
      if (localizationForm) {
        localizationForm.querySelector('[name="language_code"]').value = language;
        localizationForm.submit();
        return;
      }
      location.href = language === 'nl' ? 'https://lighting.yafico.nl/' : 'https://leuchten.yafico.de/';
      return;
    }
    locale = language;
    text = translations[locale];
    const url = new URL(location.href);
    url.searchParams.set('lang', locale);
    url.hash = '';
    history.replaceState(null, '', url);
    document.body.classList.remove('yl-dialog-open');
    productEntry = undefined;
    activeProduct = undefined;
    render();
    renderCart();
  }

  root.addEventListener('click', async event => {
    const button = event.target.closest('button, a');
    if (!button) return;
    if (button.hasAttribute('data-product')) {
      if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0 || button.target === '_blank' || button.hasAttribute('download')) return;
      const linkedProduct = products.find(product => product.id === button.dataset.product);
      if (config.productPages === true && linkedProduct && !productUrl(linkedProduct).startsWith('#')) {
        rememberCollectionPosition();
        if (button.tagName === 'BUTTON') {
          event.preventDefault?.();
          location.href = productUrl(linkedProduct);
        }
        return;
      }
      event.preventDefault?.();
      openProduct(button.dataset.product);
    }
    if (button.hasAttribute('data-cart')) await openCart();
    if (button.hasAttribute('data-lighting-variant')) changeVariant(button.dataset.variantModel, button.dataset.lightingVariant);
    if (button.hasAttribute('data-add')) await addProduct(button.dataset.add, button);
    if (button.hasAttribute('data-filter')) {
      filter = button.dataset.filter;
      root.querySelectorAll('[data-filter]').forEach(filterButton => filterButton.setAttribute('aria-pressed', filterButton.dataset.filter === filter));
      renderProducts();
    }
    if (button.hasAttribute('data-reset-filters')) resetCollectionFilters(button);
    if (button.hasAttribute('data-close')) closeDialog(button.closest('dialog'));
    if (button.hasAttribute('data-image')) await setGallery(Number(button.dataset.image));
    if (button.hasAttribute('data-gallery-step')) {
      await setGallery(galleryRequestedIndex + Number(button.dataset.galleryStep));
    }
    if (button.hasAttribute('data-remove') || button.hasAttribute('data-remove-line')) {
      if (busy) return;
      const cartFocus = captureCartFocus(button);
      busy = true;
      button.disabled = true;
      try {
        cartState = button.hasAttribute('data-remove-line') ? await cart.removeLine(button.dataset.removeLine) : await cart.remove(button.dataset.remove);
        renderCart();
      } catch (error) {
        console.error(error);
        toast(text.error);
      } finally {
        busy = false;
        button.disabled = false;
        restoreCartFocus(cartFocus);
      }
    }
    if (button.hasAttribute('data-qty-pair')) {
      if (busy) return;
      const cartFocus = captureCartFocus(button);
      busy = true;
      button.disabled = true;
      const pairId = button.dataset.qtyPair;
      const delta = Number(button.dataset.qtyDelta) || 0;
      const current = cartState.items.find(item => item.properties?._yafico_pair === pairId)?.quantity || 1;
      const next = Math.min(10, current + delta);
      try {
        cartState = next < 1 ? await cart.remove(pairId) : await cart.setQuantity(pairId, next);
        renderCart();
      } catch (error) {
        console.error(error);
        if (error.cart) cartState = error.cart;
        renderCart();
        toast(text.error);
      } finally {
        busy = false;
        button.disabled = false;
        restoreCartFocus(cartFocus);
      }
    }
    if (button.hasAttribute('data-zoom')) openZoom();
    if (button.hasAttribute('data-zoom-step')) {
      await setGallery(galleryRequestedIndex + Number(button.dataset.zoomStep));
    }
    if (button.hasAttribute('data-filter-link') && root.querySelector('#yl-product-grid')) {
      filter = ['sculptural', 'compact', 'all'].includes(button.dataset.filterLink) ? button.dataset.filterLink : 'all';
      root.querySelectorAll('[data-filter]').forEach(filterButton => filterButton.setAttribute('aria-pressed', filterButton.dataset.filter === filter));
      renderProducts();
    }
    if (button.hasAttribute('data-language')) await changeLanguage(button.dataset.language);
    if (button.hasAttribute('data-duo')) openDuo();
    if (button.hasAttribute('data-duo-add')) await addDuo(button);
    if (button.hasAttribute('data-continue')) {
      closeDialog(button.closest('dialog'));
      const collection = root.querySelector('#collection');
      if (collection) collection.scrollIntoView({ behavior: 'smooth' });
      else location.href = brandContext().collectionHref;
    }
    if (button.hasAttribute('data-policy')) {
      const kind = button.dataset.policy;
      const [title, content] = serviceInfo(kind);
      showInfo(title, content);
    }
    if (button.hasAttribute('data-preview-checkout')) showInfo(text.checkout, `<p>${locale === 'de' ? 'Diese lokale Ansicht verarbeitet keine Bestellungen oder Zahlungen. Im veröffentlichten Shopify-Shop führt diese Schaltfläche zum sicheren Checkout.' : 'Deze lokale weergave verwerkt geen bestellingen of betalingen. In de gepubliceerde Shopify-winkel gaat deze knop naar de beveiligde checkout.'}</p>`);
    if (button.hasAttribute('data-imprint')) showInfo(text.imprint, imprintContent());
    if (button.hasAttribute('data-menu')) {
      const opened = button.getAttribute('aria-expanded') !== 'true';
      button.setAttribute('aria-expanded', opened);
      root.querySelector('.yl-nav').classList.toggle('yl-nav-open', opened);
    }
    if (button.matches('.yl-nav a')) {
      root.querySelector('.yl-nav').classList.remove('yl-nav-open');
      root.querySelector('[data-menu]').setAttribute('aria-expanded', 'false');
    }
  });

  root.addEventListener('pointerover', event => {
    const thumbnail = event.target.closest('[data-image]');
    if (thumbnail && event.pointerType !== 'touch' && !thumbnail.contains(event.relatedTarget)) setGallery(Number(thumbnail.dataset.image));
  });

  root.addEventListener('focusin', event => {
    const thumbnail = event.target.closest('[data-image]');
    if (thumbnail) setGallery(Number(thumbnail.dataset.image));
  });

  root.addEventListener('keydown', event => {
    if (!event.target.closest('.yl-gallery') || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    setGallery(galleryRequestedIndex + (event.key === 'ArrowLeft' ? -1 : 1));
  });

  root.addEventListener('pointerdown', event => {
    if (event.target.closest('.yx-gallery-stage') && !event.target.closest('button')) galleryPointer = { x: event.clientX, y: event.clientY, pointerId: event.pointerId };
  });

  root.addEventListener('pointerup', event => {
    if (!galleryPointer || galleryPointer.pointerId !== event.pointerId) return;
    const horizontal = event.clientX - galleryPointer.x;
    const vertical = event.clientY - galleryPointer.y;
    galleryPointer = null;
    if (event.target.closest('.yx-gallery-stage') && Math.abs(horizontal) > 45 && Math.abs(horizontal) > Math.abs(vertical) * 1.4) {
      suppressZoomClick = true;
      setGallery(galleryRequestedIndex + (horizontal < 0 ? 1 : -1));
      setTimeout(() => { suppressZoomClick = false; }, 400);
    }
  });

  root.addEventListener('pointercancel', () => { galleryPointer = null; });

  root.addEventListener('click', event => {
    const stage = event.target.closest('[data-zoom-stage]');
    if (stage && stage.hasAttribute('data-zoom-stage')) {
      if (stage.dataset.zoomable !== 'true') return;
      const zoomed = stage.dataset.zoomed !== 'true';
      stage.dataset.zoomed = String(zoomed);
      if (zoomed) nextFrame(() => stage.scrollTo?.((stage.scrollWidth - stage.clientWidth) / 2, (stage.scrollHeight - stage.clientHeight) / 2));
      return;
    }
    const photo = event.target.closest('.yl-gallery-main');
    if (!photo || !activeProduct || event.target.closest('button')) return;
    if (suppressZoomClick) {
      suppressZoomClick = false;
      return;
    }
    openZoom();
  });

  root.addEventListener('change', event => {
    if (event.target.hasAttribute('data-footprint')) {
      footprint = ['15', '17', '18'].includes(String(event.target.value)) ? String(event.target.value) : 'all';
      event.target.value = footprint;
      renderProducts();
    }
    if (event.target.hasAttribute('data-sort')) {
      sorting = event.target.value;
      renderProducts();
    }
    if (!busy && event.target.hasAttribute('data-duo-model')) {
      renderDuoVariant(event.target.dataset.duoModel);
      updateDuo();
    }
    if (!busy && event.target.hasAttribute('data-duo-variant')) updateDuo();
  });

  root.addEventListener('click', event => {
    if (event.target.tagName === 'DIALOG') {
      const bounds = event.target.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog(event.target);
    }
  });

  root.addEventListener('close', event => {
    if (event.target.id === 'yl-zoom-dialog') zoomRevision += 1;
    if (event.target.tagName === 'DIALOG' && !root.querySelector('dialog[open]')) document.body.classList.remove('yl-dialog-open');
    if (event.target.id === 'yl-product-dialog' && !event.target.open) {
      invalidateGallery();
      if (inlineProduct) {
        activeProduct = inlineProduct;
        return;
      }
      if (productEntry) {
        history.replaceState(null, '', productEntry.url);
        applyPageMetadata(productEntry);
        productEntry = undefined;
      }
      activeProduct = undefined;
    }
  }, true);

  window.addEventListener('yafico:cart', event => {
    cartState = event.detail;
    if (root.querySelector('#yl-cart-dialog')) renderCart();
  });

  window.addEventListener('storage', async event => {
    if (preview && event.key?.startsWith('yafico')) {
      cartState = await cart.read();
      renderCart();
    }
  });

  window.addEventListener('popstate', () => {
    if (inlineProduct || pageProduct()) {
      if (inlineProduct?.id) variantSelections.delete(inlineProduct.id);
      if (inlineProduct?.id === pageProduct()?.id && String(inlineProduct?.variantId) === String(pageProduct()?.variantId)) return;
      root.querySelectorAll('dialog[open]').forEach(dialog => dialog.close());
      document.body.classList.remove('yl-dialog-open');
      activeProduct = undefined;
      galleryIndex = 0;
      render();
      renderCart();
      return;
    }
    if (!preview && root.querySelector('#yl-product-grid')) {
      const previous = { filter, footprint, sorting };
      readCollectionState();
      if (filter !== previous.filter || footprint !== previous.footprint || sorting !== previous.sorting) {
        root.querySelectorAll('[data-filter]').forEach(filterButton => filterButton.setAttribute('aria-pressed', filterButton.dataset.filter === filter));
        const footprintSelect = root.querySelector('[data-footprint]');
        if (footprintSelect) footprintSelect.value = footprint;
        const sortSelect = root.querySelector('[data-sort]');
        if (sortSelect) sortSelect.value = sorting;
        renderProducts();
      }
    }
    const product = products.find(candidate => location.hash === `#model-${candidate.id}` || productUrl(candidate) === location.pathname);
    if (product) {
      if (!productEntry && productReturnPage) productEntry = productReturnPage;
      openProduct(product.id, false);
    } else if (productEntry) {
      const metadata = productEntry;
      productEntry = undefined;
      activeProduct = undefined;
      applyPageMetadata(metadata);
      closeDialog(root.querySelector('#yl-product-dialog'));
    }
  });

  window.addEventListener('resize', () => {
    const dialog = root.querySelector('#yl-zoom-dialog');
    if (dialog?.open) configureZoom(dialog);
  });

  async function initialize() {
    try {
      initialPageMetadata = pageMetadata();
      if (normalizeBrandCountry()) return;
      let catalogue = config.catalogue;
      if (!catalogue) {
        const response = await fetch(config.catalogueUrl || asset('lighting-catalog.json'));
        if (!response.ok) throw new Error(`Catalogue: ${response.status}`);
        catalogue = await response.json();
      }
      if (!config.assetBase && config.catalogueUrl) config.assetBase = new URL('.', new URL(config.catalogueUrl, location.href)).href;
      config.kit = { price: catalogue.kitPrice, available: preview, ...config.kit };
      if (!preview && !config.kit.variantId) config.kit.price = catalogue.kitPrice;
      config.carriers = { de: 'DHL', nl: 'PostNL', ...config.carriers };
      products = catalogue.products.map(product => {
        const override = (config.productOverrides || []).find(candidate => candidate.id === product.id) || {};
        const defaults = config.productDefaults || {};
        const shadePrice = override.shadePrice ?? product.shadePrice;
        const knownMedia = product.id === '01' ? [...product.images, 'lighting-01-life-01-v4.webp'] : product.images;
        const dimensionImage = dimensionImageFor(product);
        const dimensionImages = [dimensionImage, product.dimensionImage, override.dimensionImage].filter(Boolean);
        const media = [...new Set([...(product.lifestyleImages || []), ...product.images, ...(override.images || []).filter(filename => !matchesProductMedia(filename, knownMedia))])]
          .filter(filename => typeof filename === 'string' && filename && !/dimensions-v1/i.test(mediaStem(filename)) && !matchesProductMedia(filename, dimensionImages));
        const images = product.studioImage ? [...media.filter(filename => !matchesProductMedia(filename, [product.studioImage])), product.studioImage] : media;
        const normalized = {
          ...product,
          available: preview,
          ...override,
          name: product.name,
          description: product.description,
          detail: product.detail,
          studioImage: product.studioImage,
          dimensions: dimensionText(productText(override.dimensions, config.modelDimensions?.[product.id], product.dimensions)),
          material: materialText(override.material, defaults.material?.[locale], product.material),
          manufacturer: productText(override.manufacturer, defaults.manufacturer, product.manufacturer),
          safety: {
            de: productText(override.safety?.de, defaults.safety?.de, product.safety?.de),
            nl: productText(override.safety?.nl, defaults.safety?.nl, product.safety?.nl)
          },
          shadePrice,
          price: shadePrice + config.kit.price,
          dimensionImage,
          images
        };
        return window.YaficoVariants?.prepare({ config, locale, preview }, normalized) || normalized;
      });
      cart = new window.YaficoCart({ ...config, mode: preview ? 'preview' : 'shopify' });
      if (pageProduct()) galleryIndex = 0;
      readCollectionState();
      render();
      restoreCollectionPosition();
      cartState = await cart.read();
      renderCart();
      const modelId = config.activeProductId || (location.hash.startsWith('#model-') ? location.hash.slice(7) : null);
      if (modelId && !inlineProduct) {
        const selected = selectedProduct(modelId);
        const destination = selected ? productUrl(selected) : '';
        if (config.productPages === true && destination && !destination.startsWith('#')) location.href = destination;
        else openProduct(modelId, false);
      }
      if (config.template === 'cart') await openCart();
    } catch (error) {
      console.error(error);
      if (storefrontRendered) {
        toast(text.error);
        return;
      }
      if (initialStorefrontMarkup) {
        root.innerHTML = initialStorefrontMarkup;
        root.setAttribute('data-ssr', 'true');
        return;
      }
      const contactEmail = config.contactEmail || `info@yafico.${locale}`;
      root.innerHTML = `<div class="yl-load-error"><h1>Yafico Lighting</h1><p>${text.loadError}</p><a href="mailto:${escape(contactEmail)}">${escape(contactEmail)}</a></div>`;
    }
  }

  initialize();
})();
